import Vue from "vue";
import Router from "vue-router";
// 路由meta配置说明
// {
//  keepAlive: false, // 不需要缓存当前页面
//  rank: 2, // 页面等级 2 代表字路由 hender 头部组件出现返回按钮
//  attribution: "managementguanli" // 归属父级页面 回显左侧导航菜单选择状态
// -----------------------------------------
//  type: "adhoc" // 免登陆状态
// }
// -------------资源录制 -------------------
// 手动录制视频资源
const video_Resources = () => import("@/views/wx-video-resources");
// 手动视频资源详情
const video_Resources_info = () =>
  import("@/views/wx-video-resources/look-video");
//自动录制资源
const commonResource = () => import("@/views/wx-common-resource");
//自动录制资源详情
const commonResourceInfo = () =>
  import("@/views/wx-common-resource/index_look");
// ------------- H5 移动端界面 -------------------
// 图片分享展示
const h5_imgShare = () => import("@/H5/share");
// 教研室手机链接分享
const h5_InviteLink = () => import("@/H5/InviteLink");
// 手机直播详情
const h5_LiveDetail = () => import("@/H5/liveDetail");
// 手机录播详情
const h5_VideoDetail = () => import("@/H5/videoDetail");
// 分享-缺省页
const h5_Wwh = () => import("@/H5/wwh");
// 手机登录页
const h5_login = () => import("@/H5/login");
// 手机忘记密码
const h5_forget = () => import("@/H5/forgetPwd");
// 手机修改密码
const h5_setpwd = () => import("@/H5/setPwd");
// 传屏下载app H5界面 中转
const thescreenh5 = () => import("@/H5/h5");
//手机H5绑定学校
const bindinUser = () => import("@/views/wx-bindinUser");
//手机验证码登录
const phoneNumberLogin = () =>
  import("@/views/wx-bindinUser/phoneNumber-login.vue");
//绑定用户区分
const bindinUserinfo = () => import("@/views/wx-bindinUser/bindinUserinfo.vue");
//绑定用户
const oneIndex = () => import("@/views/wx-bindinUser/oneIndex.vue");
//手机H5绑定学校
const bindinUserOk = () => import("@/views/wx-bindinUser/accomplish.vue");

// ------------- 聊天界面客户端app嵌用 -------------------

const h5_chatpc = () => import("@/H5/chat/indexPc");
const h5_chatapp = () => import("@/H5/chat/indexApp");

// ---------账号审核--------

// 账号审核
const accountIInformation = () => import("@/views/wx-account-information");

// 档案管理 ------------------------------------
// 学生档案-班级
const pupil_record = () =>
  import("@/views/wx-record/pupil_record/listpage.vue");
// 学生档案-班级-list
const pupil_record_class = () =>
  import("@/views/wx-record/pupil_record_class/listpage.vue");
const pupil_record_list = () =>
  import("@/views/wx-record/pupil_record_list/listpage.vue");
// 学生信息
const pupil_statistical = () =>
  import("@/views/wx-record/pupil_statistical/listpage.vue");

// 老师档案
const teacher_record = () =>
  import("@/views/wx-record/teacher_record/index.vue");
// 老师信息
const teacher_statistical = () =>
  import("@/views/wx-record/teacher_statistical/index.vue");

//---------------------------------------------

// ---------------------------------------------
const home = () => import("@/views/wx-home/home");
// 概览
const probable = () => import("@/views/wx-probable");
// 超管概览 （教育信息化数据）
const educationalInfo = () => import("@/views/wx-super-admin/educational-info");
// 超管概览 （设备应用数据）
const deviceApply = () => import("@/views/wx-super-admin/device-apply");
// 区管、校管概览 （教育信息化数据）
const districtdevice = () => import("@/views/wx-super-admin/district-device");
// 区管、校管概览 （设备应用数据）
const districtinfo = () => import("@/views/wx-super-admin/district-info");
// 账号管理页面
const account = () => import("@/views/wx-account");
// 账号管理查看账号权限
const viewJurisdiction = () => import("@/views/wx-account/viewJurisdiction");
// 账号管理新增
const addaccount = () => import("@/views/wx-account/wx-addaccount");
// 账号管理导入
const importtemplate = () => import("@/views/wx-account/wx-importtemplate");
// 超管 菜单更新管理
const menuUpdate = () => import("@/views/Menu-update");
// 白名单管理
const whiteList = () => import("@/views/wx-whiteList");

// 线上应用
const onlinelist = () => import("@/views/wx-application/wx-online-list");
// 版本管理
const appmanager = () => import("@/views/wx-application/wx-appmanager");
// 综合设置
const setting = () => import("@/views/wx-application/wx-setting");
//// 设备类型
const equipment = () => import("@/views/wx-equipment");
// 系统升级
const system = () => import("@/views/wx-system");
// 设备详情
const equipmentdetails = () => import("@/views/wx-system/wx-equipmentdetails");
//个人中心
const personal = () => import("@/views/wx-personal");
// 充值
// const money = () => import("@/views/wx-money");
// 确认订单 不开发票
// const affirm = () => import("@/views/wx-money/wx-affirm");
// 续费
// const renew = () => import("@/views/wx-renew");
// 购买
// const purchase = () => import("@/views/wx-purchase");
// 角色管理
const role = () => import("@/views/wx-role");
// 角色新增
const addrolePermission = () => import("@/views/wx-role-permission/add-role");
// 角色管理权限配置
const editrole = () => import("@/views/wx-editrole");
// 意见反馈
const feedback = () => import("@/views/wx-feedback");
//     // 意见反馈详情
// const particulars = () =>
//     import ('@/views/wx-feedback/wx-particulars')
// 意见反馈用户
const suggestion = () => import("@/views/wx-feedback/wx-suggestion");
// 订单记录
// const orderrecord = () => import("@/views/wx-orderrecord");
// 设备位置管理
const sitemanagement = () => import("@/views/wx-sitemanagement");
// 设备位置绑定设备详情
const sitemanagementxq = () =>
  import("@/views/wx-sitemanagement/wx-sitemanagementxq");

//教学 teaching
//演示资源
const demo = () => import("@/views/wx-teaching/wx-demo");
////演示资源 添加修改
const demoadd = () => import("@/views/wx-teaching/wx-demo/wx-demoadd");
//课堂练习
const classroom = () => import("@/views/wx-teaching/wx-classroom");
//// 添加修改
const classroomadd = () =>
  import("@/views/wx-teaching/wx-classroom/wx-classroomadd");
//云资源
const cloudres = () => import("@/views/wx-teaching/wx-cloudres");

//教学资源 - 学情分析
const studentAnalysis = () => import("@/views/wx-student-analysis");
// 个人表现
const personageManifestation = () =>
  import("@/views/wx-student-analysis/personage-manifestation");

//----------------------- 自动登录 -------------------------
// 自动登录
const automaticLogin = () => import("@/views/automatic-login");
//----------------------- 单点登录 -------------------------
// 单点登录
const SSOA = () => import("@/views/wx-SSOA");

//数据看板
//超管
const SuperTube = () => import("@/views/wx-dataBoard/SuperTube");

// 套餐管理 个人
// const personalGr = () => import("@/views/wx-packagemanagement/wx-personal");
// 套餐管理 集体
// const thecollective = () =>
import("@/views/wx-packagemanagement/wx-thecollective");
// 我的套餐
// const mypackage = () => import("@/views/wx-mypackage");

// 学校管理
//评审管理
const judge = () => import("@/views/wx-judge");
//评论管理
const comment = () => import("@/views/wx-comment");
const management = () => import("@/views/wx-management");
// 套餐明细
// const detail = () => import("@/views/wx-management/wx-detail");
// 查看明细
// const selectdetail = () =>
// import("@/views/wx-management/wx-detail/wx-selectdetail");
// 学制管理
const systemmanagement = () => import("@/views/wx-systemmanagement");
// 我的班级
const classandgrade = () => import("@/views/wx-classandgrade");
// 班级详情
const classdetails = () => import("@/components/wx-classdetails");
// 班级列表
const theclasslist = () => import("@/views/wx-theclasslist");
// 班级列表 分组详情
const groupingList = () => import("@/views/wx-theclasslist/groupingList");
// 班级列表 分组
const studentGrouping = () => import("@/views/wx-theclasslist/studentGrouping");
// 操作记录
const operation = () => import("@/views/wx-operation");
// 设备管理
const managementguanli = () => import("@/views/wx-managementguanli");
// 产品管理
const productManagement = () =>
  import("@/InteractiveAuthorization/wx-productManagement");
// 产品管理-授权
const authorization = () =>
  import("@/InteractiveAuthorization/wx-productManagement/authorization");
// 区域或学校未授权界面
const TheDominant = () => import("@/InteractiveAuthorization/TheDominant");
// 区域授权账号
const cancel_account = () =>
  import("@/InteractiveAuthorization/wx-distAuthorization/cancel-account");
// 设备管理 交互大屏 使用情况
const serviceCondition = () =>
  import("@/components/she-bei/jh/serviceCondition");
// 设备组列表
const deviceList = () => import("@/views/wx-device-list");
// 添加设备组
const addDeviceGroup = () => import("@/views/wx-device-list/add-device-group");
// 学习平板
// const stduy = () => import("@/views/wx-interaction-screen");
// 学习平板 设置
const stduy_pad = () => import("@/views/wx-interaction-screen/wx-study-pad");
// 班级设备列表
const class_device_list = () =>
  import("@/views/wx-interaction-screen/wx-class-device");
// 集控软件列表
const software_list = () =>
  import("@/views/wx-managementguanli/wx-software-manager/manager");
// 集控第三方应用管理
const third_app = () =>
  import("@/views/wx-managementguanli/wx-software-manager/third-app");
// 学习平板（时间）
const stduy_pad_time = () =>
  import("@/views/wx-interaction-screen/wx-study-pad/pad-time");
// 学习平板（护眼）
const stduy_pad_eyeshield = () =>
  import("@/views/wx-interaction-screen/wx-study-pad/eyeshield");
// 学习平板（应用）
const stduy_pad_apply = () =>
  import("@/views/wx-interaction-screen/wx-study-pad/apply");
// 学习平板（网络）
const stduy_pad_network = () =>
  import("@/views/wx-interaction-screen/wx-study-pad/network");
// 学习平板（基础设置）
const stduy_pad_basics = () =>
  import("@/views/wx-interaction-screen/wx-study-pad/basics");
// 桌面预览
// const wx_preview = () => import("@/views/wx-managementguanli/wx-preview");
const wx_preview = () =>
  import("@/views/wx-managementguanli/wx-preview-blackboard");

// 录播预览
const wx_previewa = () => import("@/views/wx-managementguanli/wx-preview2");
// 打铃设置
const wx_jow = () => import("@/views/wx-managementguanli/jow");
// 信息发布 （列表）
const wx_information_publish = () =>
  import("@/views/wx-managementguanli/wx-information-publish");
// 信息发布 （新增）
const wx_information_add = () =>
  import("@/views/wx-managementguanli/wx-information-publish/add");
// 计划任务
const wx_scheduled_task = () =>
  import("@/views/wx-managementguanli/scheduled-task");
// 计划任务
const wx_scheduled_add = () =>
  import("@/views/wx-managementguanli/scheduled-task/add");
// 远程控制
const theremotecontrol = () =>
  import("@/views/wx-managementguanli/wx-theremotecontrol");

// 文件推送
const FileToPush = () => import("@/views/wx-File-to-push");
// 文件推送新增
const addfile = () => import("@/views/wx-File-to-push/add-file");
// ------------智慧教室--------------
// 智慧教室列表
const teamModelList = () => import("@/views/team_model/list");
// 智慧教室控制
const teamModelControl = () => import("@/views/team_model/control");
//-----------------------------------
// const recordedbroadcast = () => import("@/views/wx-recorded-broadcast");
// 序列号管理
// const serialnumber = () => import("@/views/wx-serialnumber");
// 序列号详情
// const detailpagenumber = () => import("@/views/wx-serialnumber/wx-detailpage");
// 后台日志
const hotaithelog = () => import("@/views/wx-hotaithelog");
// 异常日志
const abnormal = () => import("@/views/wx-abnormal");
// 异常详情
const abnormalxq = () => import("@/views/wx-abnormal/wx-xq");
// 学校管理详情
const managementdetails = () =>
  import("@/views/wx-management/wx-managementdetails");
// 登录日志
const loginlog = () => import("@/views/wx-loginlog");
// 404
const faid = () => import("@/views/wx-404");
//500
const error = () => import("@/views/wx-500");
// loading
const loading = () => import("@/views/wx-loading");
//------------资产管理-校管-----------
// 教学楼
const ZCGL_jiaoxuelou = () =>
  import("@/views/wx-assets-management/jiaoxuelou-guanli");
// 教室
const ZCGL_jiaoshi = () =>
  import("@/views/wx-assets-management/jiaoshi-guanli");
// 设备列表
const ZCGL_shebei = () => import("@/views/wx-assets-management/shebei-guanli");
// 教室新增
const ZCGL_jiaoshiadd = () =>
  import("@/views/wx-assets-management/jiaoshi-guanli/add");
// 教室导入
const ZCGL_import = () =>
  import("@/views/wx-assets-management/jiaoshi-guanli/importupdata");
// 网络摄像机
const Wxebcam = () => import("@/components/she-bei/wl/add");
// 实验室
const laboratory = () => import("@/views/wx-assets-management/laboratory");
// 新增
const laboratoryadd = () =>
  import("@/views/wx-assets-management/laboratory/add");
//------------学制管理-校管-----------
const XZGL_nj = () => import("@/views/wx-xz-guanli/nj-guanli");
const XZGL_xk = () => import("@/views/wx-xz-guanli/xk-guanli");
//------------关联管理-校管-----------
const wx_associated_guanli = () => import("@/views/wx-associated-guanli");
const wx_assicuated_add = () =>
  import("@/views/wx-associated-guanli/add-relevance-school");
const wx_associated_rea = () => import("@/views/wx-associated-area");
//------------关联管理-区管-----------
const wx_associated_business = () =>
  import("@/views/wx-associated-area/add-relevance-business");
const create_area_relevance = () =>
  import("@/views/wx-associated-area/create-area-relevance");
const wx_district_add = () => import("@/components/wx-district-add");
//------------高级管理-----------
const wxSeniorManagement = () => import("@/views/wx-senior-management");
//------------关联管理-超管-----------
const wx_associated_admin = () => import("@/views/wx-associated-admin");
//------------关联管理-校管 班级关联-----------
const wx_associated_school = () => import("@/views/wx-associated-school");
const wx_add_associated_admin = () =>
  import("@/views/wx-associated-admin/wx-add-associated");
const wx_district_management = () => import("@/views/wx-district-management");
const wx_learning_period = () => import("@/views/wx-learning-period");

//------------  行为分析 -----------
// 今日整体数据看板
const todayDataBlackboard = () => import("@/views/face/data-blackboard/todayDataBlackboard");
// 班级数据看板
const classDataBlackboard = () => import("@/views/face/data-blackboard/classDataBlackboard");
// 教师数据看板
const teacherDataBlackboard = () => import("@/views/face/data-blackboard/teacherDataBlackboard");
// 学生数据看板
const studentDataBlackboard = () => import("@/views/face/data-blackboard/studentDataBlackboard");
// AI课堂
const analysisresult = () => import("@/views/face/bhanalysisInfo");
// AI课堂-二阶段
const aiClassroom = () => import("@/views/face/AI/analysisresult-classroom");
// AI课堂-数据总览
const dataOverview = () => import("@/views/face/AI/detail/dataOverview");
// AI课堂-对比分析
const dataComparison = () => import("@/views/face/AI/detail/dataComparison");
// AI课堂-AI分析（详情默认页面（全部）- 对比分析 + 报告页面（分页））
const aiDetail = () => import("@/views/face/AI/detail");
// AI监考
const aiInvigilate = () => import("@/views/face/AI/analysisresult-invigilate");
// AI分析详情页面
const aiInvigilateDetail = () => import("@/views/face/AI/invigilate/detail");
// AI监考通知预警
const aiInvigilateAlarm = () => import("@/views/face/AI/invigilate/alarm");
// AI考勤
const aiAttendance = () => import("@/views/face/AI/analysisresult-attendance");
// AI考勤-超管
const aiAttendanceAdmin = () => import("@/views/face/AI/attendance/analysisresult-admin");
// AI考勤-区管
const aiAttendanceGovernor = () => import("@/views/face/AI/attendance/analysisresult-governor");
// AI考勤-校管
const aiAttendancePrincipal = () => import("@/views/face/AI/attendance/analysisresult-principal");
// AI考勤-详情页面
const aiAttendanceGrade = () => import("@/views/face/AI/attendance/analysisresult-grade");
// AI考勤-校级管理员班级列表、教师智能考勤默认页面（课程）
const aiAttendanceCourse = () => import("@/views/face/AI/attendance/analysisresult-course");
// 服务管理
const aiServerManager = () => import("@/views/face/AI/server-manager");
// 高级设置
const aiSetConfig = () => import("@/views/face/AI/set-config");
// AI课堂-查看分析结果
const analysisresultresult = () => import("@/views/face/analysisresultresult");
// 设备巡视
const lookpatrol = () => import("@/views/face/lookpatrol");
// 人脸库
const importPhotos = () => import("@/views/face/importPhotos");
// 设置-服务器IP
const serverInfo = () => import("@/views/face/serverInfo");
// 设备管理（云平台-表格版）
const managementguanlitable = () =>
  import("@/views/face/wx-face-recognition-table");

// ----------注册页面-------
const register = () => import("@/views/wx-register");

//---------家长管理----------
// 家长管理
const patriarch = () => import("@/views/wx-patriarch-management");
// 家长个人中心
const personalPatriarch = () => import("@/views/wx-personal-patriarch");
// ------------  教务  ------------
// 课程管理
const wx_course_management = () => import("@/views/wx-course-management");
// 课程导入
const import_data = () => import("@/views/wx-course-management/import-data");
// 新增课程管理
const add_course = () => import("@/views/wx-course-management/addORset");
//教师管理
const teachermanage = () => import("@/views/wx-teachermanage");
const addteacher = () => import("@/views/wx-teachermanage/wx-addteacher");
const teacherimpot = () => import("@/views/wx-teachermanage/wx-importtemplate");
//班级管理
const classmanage = () => import("@/views/wx-classmanage");
const addclass = () => import("@/views/wx-classmanage/wx-addteacher");
const classimpot = () => import("@/views/wx-classmanage/wx-importtemplate");
//学生管理
const pupilmanage = () => import("@/views/wx-pupilmanage");
const addpupil = () => import("@/views/wx-pupilmanage/wx-addpupil");
const pupilimpot = () => import("@/views/wx-pupilmanage/wx-importtemplate");

// ------------教研------------
// 教研室链接跳转页面
const roomlink = () => import("@/views/wx-research-room/roomlink");
//教研室
const researchroom = () => import("@/views/wx-research-room");
//教研室详情
const roomparticulars = () => import("@/views/wx-research-room/particulars");
//创建教研室
const addresearchroom = () =>
  import("@/views/wx-research-room/wx-addresearchroom");
//教研室更多
const roomevenOne = () => import("@/views/wx-research-room/roomevenOne");
//教学研讨更多
const roomevenTwo = () => import("@/views/wx-research-room/roomevenTwo");
//协同备课更多
const roomevenThree = () => import("@/views/wx-research-room/roomevenThree");
//共享资料更多
const roomevenFour = () => import("@/views/wx-research-room/roomevenFour");
//教研权限
const jurisdiction = () => import("@/views/wx-research-room/jurisdiction");
//创建教研
const creatResearch = () => import("@/views/wx-research-room/creatResearch");
//创建备课
const creatlessons = () => import("@/views/wx-research-room/creatlessons");
//创建备课 one
const onesetout = () =>
  import("@/views/wx-research-room/creatlessons/onesetout");
//创建备课 two
const twofees = () => import("@/views/wx-research-room/creatlessons/twofees");
//创建备课  three
const threeupload = () =>
  import("@/views/wx-research-room/creatlessons/threeupload");
//创建备课  four
const rethinkfour = () =>
  import("@/views/wx-research-room/creatlessons/rethinkfour");
//参与备课
const prepareResearch = () =>
  import("@/views/wx-research-room/prepareResearch");
//教研详情
const detailsResearch = () =>
  import("@/views/wx-research-room/detailsResearch");

// ------------学期校历管理------------
// 学期管理
const wx_semester_calendar = () => import("@/views/wx-semester-calendar");
// 学期新增
const semester = () => import("@/views/wx-semester-calendar/semester");
// 校历设置
const calendar = () => import("@/views/wx-semester-calendar/calendar");
// 作息时间
const timetable = () => import("@/views/wx-semester-calendar/timetable");
//教研组管理
const resmanage = () => import("@/views/wx-resmanage");
const resimpot = () => import("@/views/wx-resmanage/wx-importtemplate");
//排课   ——————————排课——————————————
const scheduling = () => import("@/views/wx-scheduling");
//新增排课
const addscheduling = () => import("@/views/wx-scheduling/addscheduling");
//指定页面
const assign = () => import("@/views/wx-scheduling/assign");
//指定教师页面
const assignTeacher = () =>
  import("@/views/wx-scheduling/assign/assignTeacher");
//指定教室页面
const assignclassroomOut = () =>
  import("@/views/wx-scheduling/assign/assignclassroomOut");
//指定教室页面
const assignclassroom = () =>
  import("@/views/wx-scheduling/assign/assignclassroom");
//合班
const combineclass = () => import("@/views/wx-scheduling/assign/combineclass");
//禁排
const taboo = () => import("@/views/wx-scheduling/assign/taboo");
//固定预排
const fixation = () => import("@/views/wx-scheduling/assign/fixation");
//排课结果
const result = () => import("@/views/wx-scheduling/assign/result");
//排课结果调课
const resultdebug = () => import("@/views/wx-scheduling/assign/resultdebug");
//手动排课
const manual = () => import("@/views/wx-scheduling/assign/manual");

//自动课表
const autoClassSchedule = () => import("@/views/wx-auto-classSchedule");
//关联教室
const relevanceRoom = () => import("@/views/wx-auto-classSchedule/index_look");


//调课 ---------调课----------------
const switching = () => import("@/views/wx-switching");
// ------------课表查询------------
const wx_curriculum = () => import("../views/wx_curriculum_inquiry");
// ------------业务管理------------
const wx_business = () => import("../views/wx-business-guanli");
// ------------课堂记录------------
// 老师课堂记录列表
const class_register = () =>
  import("@/views/wx-class-register/teacher-class-register");
// 老师课堂记录详情
const record_details = () => import("@/views/wx-class-register/record-details");
// 课堂出题详情查看
const topic_perview = () =>
  import("@/views/wx-class-register/record-details/classdialog");
// 课堂分组详情查看
const grouping = () =>
  import("@/views/wx-class-register/record-details/grouping");
// 课堂记录 解锁  锁屏 查看学生信息
const student_view = () => import("@/components/student-view");

// ------------------教学活动------------------
// 课前预习
const preview = () => import("@/views/wx-teaching-activities/preview");
// 课后任务
const task = () => import("@/views/wx-teaching-activities/task");
// 发布预习
const release_preview = () =>
  import("@/views/wx-teaching-activities/preview/release_preview");
// 预习详情
const reselease_detail = () =>
  import("@/views/wx-teaching-activities/preview/release_detail");
// 预习批改
const reselease_correction = () =>
  import("@/views/wx-teaching-activities/preview/correction");
// 发布任务
const release_task = () =>
  import("@/views/wx-teaching-activities/task/release_task");
// 任务详情
const task_detail = () =>
  import("@/views/wx-teaching-activities/task/task_detail");
// 批改任务
const correction = () =>
  import("@/views/wx-teaching-activities/task/correction");
// 个人推送报告详情界面
const Individualreport = () =>
  import("@/views/wx-teaching-activities/Individualreport");
// 班级推送报告详情界面
const Theclassreport = () =>
  import("@/views/wx-teaching-activities/Theclassreport");
//----------------------成绩管理------------------------------
// 成绩管理列表
const score_management = () => import("@/views/wx-score-management");
// 新增导入成绩
const score_importtemplate = () =>
  import("@/views/wx-score-management/wx-importtemplate");
// 考试分析
const performance_analyse = () =>
  import("@/views/wx-score-management/score-analyse");
// 区管成绩管理列表
const wx_areaOfTube_score = () => import("@/views/wx-areaOfTube-score");
// 区管成绩管理 详情
const wx_areaOfTube_scoreDetail = () =>
  import("@/views/wx-areaOfTube-score/area_score_detail");
// 教室/区管查看学生成绩详情
const stundetScoreDetail = () =>
  import("@/views/wx-areaOfTube-score/student_scoreDetail");
//----------------------升级管理------------------------------
// 固件升级
const firmware_upgrade_management = () => import("@/views/wx-Upgrade/firmware");
// pad升级
const pad_upgrade_management = () => import("@/views/wx-Upgrade/pad");
// pc升级
const pc_upgrade_management = () => import("@/views/wx-Upgrade/pc");

//----------------------- 考试管理 -------------------------
// 考试管理-列表
const exam_management = () => import("@/views/wx-exam-management");
// 准考证
const exam_card = () => import("@/views/wx-exam-management/wx-exam-card");
//  考场人员分配信息
const exam_people = () => import("@/views/wx-exam-management/wx-exam-people");
// 考场新增
const examination_detail = () =>
  import("@/views/wx-exam-management/wx-exam-detail");
//  考场设置
const exam_set = () => import("@/views/wx-exam-management/wx-exam-set");
//  考生设置
const exam_handlestudent = () =>
  import("@/views/wx-exam-management/wx-exam-student");
//  阅卷人员设置
const exam_handleteacher = () =>
  import("@/views/wx-exam-management/wx-exam-teacher");
//  视频阅卷
const exam_reviews = () => import("@/views/wx-exam-management/wx-exam-reviews");
//  线上阅卷
const exam_line_reviews = () =>
  import("@/views/wx-exam-management/wx-exam-line-reviews");
//  实验考试（考生、阅卷、监考人员选择）
const experiment_peopele = () =>
  import("@/views/wx-exam-management/wx-experiment-people");
//----------------------- 争议仲裁 -------------------------
// 争议仲裁 - 列表
const dispute_arbitration = () => import("@/views/wx-dispute-arbitration");
// 争议仲裁 - 处理
const stay_dispose = () =>
  import("@/views/wx-dispute-arbitration/wx-stay-dispose");
// 争议仲裁 - 阅卷人员选择
const stay_exam_reviews = () =>
  import("@/views/wx-dispute-arbitration/wx-exam-teacher");
// 仲裁-重新阅卷
const stay_arbitration_exam_reviews = () =>
  import("@/views/wx-dispute-arbitration/wx-exam-arbitration-review");
// 仲裁结果
const stay_arbitration_exam_result = () =>
  import("@/views/wx-dispute-arbitration/wx-exam-arbitration-result");
// 仲裁阅卷
const stay_arbitration_reviews = () => import("@/views/wx-arbitration-reviews");

// ----------------------德育管理-----------------------------
// 评价管理
const evaluation_management = () => import("@/views/wx-evaluation-management");
// 评价详情
const evaluation_detail = () => import("@/views/wx-evaluation-detail");

// ----------------------校园OA-----------------------------
// 校园OA
const school_office = () => import("@/views/wx-school-office");
// 新建表单
const school_create_form = () =>
  import("@/views/wx-school-office/components/school-create-form");
//表单详情
const school_form_details = () =>
  import("@/views/wx-school-office/components/school-form-details");

// ----------------------数据驾驶舱-----------------------------
// 数据总览
const dataScreening = () => import("@/views/wx-data-cockpit/wx-data-screening");
// 区域数据
const areaData = () => import("@/views/wx-data-cockpit/wx-area-data");
// 学校数据
const schoolData = () => import("@/views/wx-data-cockpit/wx-school-data");
// 教职工数据
const staffData = () => import("@/views/wx-data-cockpit/wx-staff-data");
// 教学档案
const staffArchives = () => import("@/views/wx-data-cockpit/components/teacher_statistical");
//学生数据
const studentData = () => import("@/views/wx-data-cockpit/wx-student-data");
// 学习档案
const studentArchives = () => import("@/views/wx-data-cockpit/components/pupil_statistical");
// 平台数据
const platformData = () => import("@/views/wx-data-cockpit/wx-platform-data");
// 软件数据
const softwareData = () => import("@/views/wx-data-cockpit/wx-software-data");
// 设备数据
const equipmentData = () => import("@/views/wx-data-cockpit/wx-equipment-data");
// 设备详情
const equipmentDataDetails = () =>
  import(
    "@/views/wx-data-cockpit/wx-equipment-data/components/wx-equipment-details"
  );
//*****************************************************
//----------------------云平台-前台------------------------------

//学科网 H5 客户端嵌套web
const subject_network = () => import("@/views/front/subject_network");
//状元网 H5 客户端嵌套web
const wx_mfzy = () =>
  import("@/views/wx-teaching/wx-demo/h5nest/zhuangyuanwang");
//状元网 H5 客户端嵌套web 展示资源
const wx_mfzy_video = () =>
  import("@/views/wx-teaching/wx-demo/h5nest/aliyun_video");
//21世纪 H5 客户端嵌套web 展示资源
const wx_century21 = () =>
  import("@/views/wx-teaching/wx-demo/h5nest/wx_century21");
//21世纪 H5 客户端嵌套web资源
const wxResourceAll = () =>
  import("@/views/wx-teaching/wx-demo/h5nest/resourceAll");

// 云平台-前台
const front = () => import("@/views/front");
// 首页
const frontHome = () => import("@/views/front/home");
const frontHomeNew = () => import("@/views/front/homeNew2");
// 图书馆大数据平台
const libraryBigData = () => import("@/views/libraryBigData");
// 智慧校园应用概览
const smartSchool = () => import("@/views/smartSchool");
// 智慧校园应用详情
const appliedStatistics = () => import("@/views/smartSchool/appliedStatistics");
// 专递课程
const frontCourse = () => import("@/views/front/course");
// 名师教研
const frontFamousTeacher = () => import("@/views/front/famousTeacher");
// 名校课程
const frontEliteSchool = () => import("@/views/front/eliteSchool");
// 资源超市
const fribtTeacherResourcesHome = () => import("@/views/front/teacherResourcesHome");
// 资源中心
const frontTeacherResources = () => import("@/views/front/teacherResources");
// 题库中心
const  frontQuestionBankCenter = () => import("@/views/front/questionBankCenter");
// 题库中心 试卷详情
const  frontQuestionBankCenter_Info = () => import("@/views/front/questionBankCenter/wx-combination_info");
// 新闻公告
const frontNewsBulletin = () => import("@/views/front/newsBulletin");
// 状元网资源详情
const frontResourcesZhuangDetail = () =>
  import("@/views/front/resourcesZhuangDetail");
// 结对组详情
const frontPartnerDetail = () => import("@/views/front/partnerDetail");
// 专递直播详情
const frontCourseLiveDetail = () => import("@/views/front/courseLiveDetail");
// 教研室详情
const frontResearchDetail = () => import("@/views/front/researchDetail");
// 教学研讨详情
const frontTeachingResearch = () => import("@/views/front/teachingResearch");
// 评比活动详情
const frontAppraisalDetail = () => import("@/views/front/appraisalDetail");
// 作品详情
const frontWorkDetail = () => import("@/views/front/workDetail");
// 学校详情
const frontSchoolDetail = () => import("@/views/front/schoolDetail");
// 直播详情
const frontLiveDetail = () => import("@/views/front/liveDetail");
// 直播详情-分享
const frontLiveDetailFx = () => import("@/views/front/liveDetailFx");
// 点播详情
const frontVideoDetail = () => import("@/views/front/videoDetail");
// 点播详情-分享
const frontVideoDetailFx = () => import("@/views/front/videoDetailFx");
// 新闻公告详情
const frontNewsDetail = () => import("@/views/front/newsDetail");
// 浏览更多
const frontLoadMore = () => import("@/views/front/loadMore");
// 我的收藏--名师教研
const frontTeacherCollect = () => import("@/views/front/teacherCollect");
// 观看历史--名校课程
const frontVideoHistory = () => import("@/views/front/videoHistory");
// 缺省页
const wwh = () => import("@/views/wx-wwh");

//*****************************************************
//---------------------后台-前台管理------------------------------
// 前台管理
const frontAdmin = () => import("@/views/wx-front-admin");
// 私有化-前台管理
const frontAdminPrivate = () => import("@/views/wx-front-admin-private");

//----------------------- 学生端路由 -------------------------
// 课前预习
const student_prepare = () => import("@/student/wx-prepare");
// 课前详情
const student_detail = () => import("@/student/wx-prepare/wx-detail");
// 课后任务
const student_tasks = () => import("@/student/wx-tasks");
// 课前详情
const student_tasksdetail = () => import("@/student/wx-tasks/wx-detail");
// 错题本
const student_wrongtopic = () => import("@/student/wx-wrongtopic");
// 错题重做
const wrong_topic_redo = () =>
  import("@/student/wx-wrongtopic/wx-wrong-topic-redo");
// 课堂记录
const student_classregister = () => import("@/student/wx-classregister");
// 课堂详情
const studentRecord_particulars = () =>
  import("@/student/wx-classregister/studentRecord_particulars");
// 课堂题库详情
const write_the_details = () =>
  import("@/student/wx-classregister/write_the_details");

//-----------------------------------------------------------
//*****************************************************

//----------------------- 考务 -------------------------
// 试题库
const testQuestions = () => import("@/views/wx-testQuestions_mansgement");
// 试题库-目录管理
const catalogue = () =>
  import("@/views/wx-testQuestions_mansgement/catalogue.vue");
//新增试题
const addQuestions = () =>
  import("@/views/wx-testQuestions_mansgement/addQuestions.vue");
//试题上报   试题审核
const testQuestions_putIn = () =>
  import("@/views/wx-testQuestions_putIn");
// 智能组卷
const combinationSmart = () =>
import("@/views/wx-combination_smart");

//试卷库
const testQuestions_testPaper = () =>
import("@/views/wx-testQuestions_testPaper");
//组卷预览
const combination = () =>
  import("@/views/wx-combination");
  // 试卷上报   试卷审核
const testQuestions_putIn_testPaper = () =>
import("@/views/wx-testQuestions_putIn_testPaper");

  //试卷详情
const combinationInfo = () =>
  import("@/views/wx-testQuestions_testPaper/wx-combination_info");


// 试卷
const testPaper = () => import("@/views/wx-test-paper");
//  新增试卷
const addtestPaper = () => import("@/views/wx-test-paper/add-testpaper");
//-----------------------------------------------------------

//----------------------- 考试 -------------------------
//考试列表
const examination = () => import("@/views/wx-examination");
// 考试抽签
const drawlots = () => import("@/views/wx-examination/drawlots");
// 距离最一次考试倒计时
const countdown = () => import("@/views/wx-examination/countdown");
//开始考试
const The_exam_will_begin = () =>
  import("@/views/wx-examination/The-exam-will-begin");
// 实验考试
const test = () => import("@/views/wx-examination/test");
// 查看考试试卷
const detail_Educational = () =>
  import("@/views/wx-examination/detail_Educational");
//-----------------------------------------------------------
//*****************************************************
//----------------------- 评比活动 -------------------------
// 评比活动
const appraisal = () => import("@/views/wx-appraisal");
// 评比活动添加修改页面
const addappraisal = () => import("@/views/wx-appraisal/wx-addappraisal");

//*****************************************************
//----------------------- 课程 -------------------------
// 直播课程
const live_curriculum = () => import("@/views/wx-live_curriculum");
// 直播课程
const add_curriculum = () =>
  import("@/views/wx-live_curriculum/add_curriculum");
// 回看
const back_look = () => import("@/views/wx-live_curriculum/back_look");
// 学习课程
const study_curriculum = () => import("@/views/wx-study_curriculum");
// 上传课程
const add_upload_course = () =>
  import("@/views/wx-study_curriculum/add_upload_course");

// 课程审核列表
const curriculum_aduit = () => import("@/views/wx-curriculum_aduit");
// 课程审核
const aduit = () => import("@/views/wx-curriculum_aduit/aduit_index.vue");
// 预览
const aduitA = () => import("@/views/wx-curriculum_aduit/aduit_index.vue");

//-----------------------------------------------------------
//*****************************************************

//*****************************************************
//----------------------- 组织管理 -------------------------
// 部门管理
const Department_management = () => import("@/views/wx-Department_management");

// 职工管理
const Staff_management = () => import("@/views/wx-Staff_management");
// 职工添加
const addStaff = () => import("@/views/wx-Staff_management/wx-addStaff");
// 职工导入
const Staff_importtemplate = () =>
  import("@/views/wx-Staff_management/wx-importtemlate");
// 职位管理
const Position_management = () => import("@/views/wx-Position_management");
// 新增职位管理
const Position_managementAdd = () =>
  import("@/views/wx-Position_management/add");
// 教职工查询 Faculty
const Faculty = () => import("@/views/wx-Faculty");
//教职工详情
const queryStaff = () => import("@/views/wx-Faculty/wx-queryStaff");

//-----------------------------------------------------------
//*****************************************************

//*****************************************************
//----------------------- 请假管理 -------------------------
// 假期管理
const Holiday_management = () => import("@/views/wx-Holiday_management");

// 表单管理
const form_management = () => import("@/views/wx-form_management");
// 表单设置
const form_managementset = () => import("@/views/wx-form_management/set");
// 请假管申请
const Leave_management_approval = () =>
  import("@/views/wx-Leave_management_approval");
// 新增请假申请
const Leave_management_approvalAdd = () =>
  import("@/views/wx-Leave_management_approval/add");
// 请假审批
const Leave_approval = () => import("@/views/wx-Leave_approval");
// 审批/详情
const approval = () => import("@/views/wx-Leave_approval/approval");

// 调课申请
const Approvalofcourse_adjustment = () =>
  import("@/views/wx-Approvalofcourse_adjustment");
// 新增调课申请
const class_switching_approval = () =>
  import("@/views/wx-Approvalofcourse_adjustment/add");

// 调课审批
const Coursetransfer_application = () =>
  import("@/views/wx-Coursetransfer_application");
// 调课审批通过/不通过
const Coursetransfer_approval = () =>
  import("@/views/wx-Coursetransfer_application/add");

//-----------------------------------------------------------
//*****************************************************

//----------------------- 在线听评课 -------------------------
// 自主学习
const AutonomousLearning = () => import("@/views/wx-AutonomousLearning");
// 自主学习-资源详情
const selfStudyDetails = () => import("@/views/wx-selfStudyDetails");
// 自主学习-练习题详情
const selfStudyExercises = () => import("@/views/wx-selfStudyExercises");
// 学段学科管理
const resourceManage = () => import("@/views/wx-resourceManage");
// 资源目录
const resourceCatalog = () => import("@/views/wx-resourceCatalog");
// 个人资源列表
const resourcePersonage = () => import("@/views/wx-resourcePersonage");
// 上传资源
const resourceUpload = () => import("@/views/wx-resourceUpload");
// 资源审核
const resourceAudit = () => import("@/views/wx-resourceAudit");
// 听评课页面
const Onlinelisteningevaluation = () =>
  import("@/views/wx-Onlinelisteningevaluation");

// 发表听课留言
const Post_ecture_Notes = () =>
  import("@/views/wx-Onlinelisteningevaluation/wx-Post_ecture_Notes");
// 在线听评课--PC分享页
const frontCurriculumEvaluationFx = () =>
  import("@/views/wx-Onlinelisteningevaluation/wx-Post_ecture_Notes/indexFx");

// 发表听课留言-h5分析页
const Post_ecture_Notes_h = () =>
  import("@/H5/liveEvaluation");

// 创建听评课
const Createlistening = () =>
  import("@/views/wx-Onlinelisteningevaluation/wx-Createlistening");

// 听评课详情
const Teacher_classification = () =>
  import("@/views/wx-Onlinelisteningevaluation/wx-Teacher_classification");

// 上传录播课
const broadcasting_course = () =>
  import("@/views/wx-Onlinelisteningevaluation/wx-broadcasting_course");

// 管理听评课
const Management_listening = () => import("@/views/wx-Management_listening");
//-----------------------------------------------------------
//*****************************************************

//----------------------- 公文管理 -------------------------
// 公文管理
const documentManagement = () => import("@/views/wx-document_management");
// 收文登记
const Receipt_of_registration = () =>
  import("@/components/wx-document_management/Receipt_of_registration");
// 敏感词
const sensitive = () => import("@/views/wx-sensitive");
//-----------------------------------------------------------
//*****************************************************

//----------------------- 信息中心 -------------------------
// 信息中心
const informationCenter = () => import("@/views/wx-information-center");
// 信息详情
const informationDetail = () =>
  import("@/views/wx-information-center/wx-information");
// 回复
const informationReply = () => import("@/views/wx-information-center/wx-reply");
// 转发
const informationTransmit = () =>
  import("@/views/wx-information-center/wx-transmit");
// 草稿箱
const drafts = () => import("@/views/wx-information-center/wx-drafts");
// 编辑草稿
const editDrafts = () => import("@/views/wx-information-center/wx-draft-edit");
// 回收站
const recycleBin = () => import("@/views/wx-information-center/wx-recycle-bin");

//-----------------------------------------------------------
//*****************************************************

//----------------------- 传递课堂 -------------------------
// 传递课堂列表
const PassedtheClassroom = () => import("@/views/PassedtheClassroom");
// 传递课堂新增
const PassedtheClassroomAdd = () => import("@/views/PassedtheClassroom/add");
// 传递课表
const delivery_schedule = () =>
  import("@/views/PassedtheClassroom/delivery_schedule");
//-----------------------------------------------------------
//*****************************************************

//----------------------- 互动授权管理 -------------------------
// 互动授权管理
const authorizedManage = () => import("@/views/wx-authorized-manage");
// 学校授权
const schoolAuthorized = () =>
  import("@/views/wx-authorized-manage/school-authorized");
// 角色授权
const roleAuthorized = () =>
  import("@/views/wx-authorized-manage/role-authorized");
// 区管授权
const regionalAuthorized = () =>
  import("@/views/wx-authorized-manage/regional-authorized");
//-----------------------------------------------------------
//*****************************************************

//----------------------- 管理 -------------------------
// 公告管理
const bulletinAdmin = () => import("@/views/wx-bulletin-admin");
// 新增公告
const bulletinAdd = () => import("@/views/wx-bulletin-add");

//----------------------- 在线巡课 -------------------------
// 巡逻首页
const onlinePatrolClass = () => import("@/views/online-patrol-class");
// 在线巡课
const cruiseLessonVideo = () =>
  import("@/views/online-patrol-class/cruise-lesson-video");
// 在线巡课-视频文件
const cruiseLessonFile = () =>
  import("@/views/online-patrol-class/cruise-lesson-file");
//-----------------------------------------------------------
//*****************************************************

// -----------------------教务  在线巡课 -------------------------
// 巡课模块
const patro = () => import("@/views/patrol3.0");
const patroJldetail = () => import("@/views/patrol3.0/jl_detail.vue");
// 服务器数据
const serverData = () => import("@/views/patrol3.0/serverData");
const serverDataView = () => import("@/views/patrol3.0/serverDataView");
// 巡课分组
const patrolGroupingList = () => import("@/views/patrol-grouping-list");
// 添加巡课分组
const addPatrolGroup = () =>
  import("@/views/patrol-grouping-list/add-patrol-group");
// 子服务管理
const subserver = () => import("@/views/subserver");
//-----------------------------------------------------------
//*****************************************************
//----------------------- 外部使用 -------------------------
// 单点登录中转页
const autoLoginTemplate = () => import("@/views/wx-auto-login");
//-----------------------------------------------------------
//*****************************************************

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "",
      component: front,
      redirect: "/front/home",
      children: [
        // 单点登录中转页
        {
          path: "/autoLogin",
          name: "autoLoginTemplate",
          component: autoLoginTemplate,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true // 无token状态下，是否可以访问。(前台专属)
          }
        },
        {
          // 前台首页
          path: "/front/home",
          name: "frontHome",
          // component: frontHome,
          component: frontHomeNew,
          meta: {
            keepAlive: true, // 不需要缓存当前页面
            activePath: true, // 无token状态下，是否可以访问。(前台专属)
            index: "1"
          }
        },
        // {
        //   // 新版 前台首页
        //   path: "/front/homeNew",
        //   name: "frontHomeNew",
        //   component: frontHomeNew,
        //   meta: {
        //     keepAlive: true, // 不需要缓存当前页面
        //     activePath: true, // 无token状态下，是否可以访问。(前台专属)
        //     index: "1"
        //   }
        // },
        {
          // 专递课堂
          path: "/front/frontCourse",
          name: "frontCourse",
          component: frontCourse,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true,
            index: "2"
          }
        },
        {
          // 名师教研
          path: "/front/famousTeacher",
          name: "frontFamousTeacher",
          component: frontFamousTeacher,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true,
            index: "3"
          }
        },
        {
          // 名校课程
          path: "/front/eliteSchool",
          name: "frontEliteSchool",
          component: frontEliteSchool,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true,
            index: "4"
          }
        },
        {
          // 资源超市
          path: "/front/teacherResources",
          name: "fribtTeacherResourcesHome",
          component: fribtTeacherResourcesHome,
          meta: {
            keepAlive: true, // 需要缓存当前页面
            activePath: true,
            index: "5"
          }
        },
        {
          // 资源中心
          path: "/front/teacherResourcesDetails",
          name: "frontTeacherResources",
          component: frontTeacherResources,
          meta: {
            keepAlive: true, // 需要缓存当前页面
            activePath: true,
            index: "5"
          }
        },
        {
          // 新闻公告
          path: "/front/newsBulletin",
          name: "frontNewsBulletin",
          component: frontNewsBulletin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true,
            index: "6"
          }
        },
         {
          // 试题中心
          path: "/front/questionBankCenter",
          name: "frontQuestionBankCenter",
          component: frontQuestionBankCenter,
          meta: {
            keepAlive: true, // 需要缓存当前页面
            activePath: false,
            index: "8"
          }
        },
         {
          // 试题中心 试卷详情
          path: "/front/frontQuestionBankCenter_Info",
          name: "frontQuestionBankCenter_Info",
          component: frontQuestionBankCenter_Info,
          meta: {
            keepAlive: false, // 需要缓存当前页面
            activePath: false,
            index: "8"
          }
        },
        {
          // 状元网资源详情
          path: "/front/resourcesZhuangDetail",
          name: "frontResourcesZhuangDetail",
          component: frontResourcesZhuangDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true,
            index: "5"
          }
        },
        {
          // 结对组详情
          path: "/front/partnerDetail",
          name: "frontPartnerDetail",
          component: frontPartnerDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: false,
            index: "2"
          }
        },
        {
          // 专递直播详情
          path: "/front/courseLiveDetail",
          name: "frontCourseLiveDetail",
          component: frontCourseLiveDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true,
            index: "2"
          }
        },
        {
          // 教研室详情
          path: "/front/researchDetail",
          name: "frontResearchDetail",
          component: frontResearchDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: false,
            index: "3"
          }
        },
        {
          // 教学研讨详情
          path: "/front/teachingResearch",
          name: "frontTeachingResearch",
          component: frontTeachingResearch,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: false,
            index: "3"
          }
        },
        {
          // 评比活动详情
          path: "/front/appraisalDetail",
          name: "frontAppraisalDetail",
          component: frontAppraisalDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: false
          }
        },
        {
          // 作品详情
          path: "/front/workDetail",
          name: "frontWorkDetail",
          component: frontWorkDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true
          }
        },
        {
          // 学校详情
          path: "/front/schoolDetail",
          name: "frontSchoolDetail",
          component: frontSchoolDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true
          }
        },
        {
          // 直播详情
          path: "/front/liveDetail",
          name: "frontLiveDetail",
          component: frontLiveDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: false
          }
        },
        {
          // 直播详情-分享
          path: "/front/liveDetailFx",
          name: "frontLiveDetailFx",
          component: frontLiveDetailFx,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true
          }
        },
        {
          // 点播详情
          path: "/front/videoDetail",
          name: "frontVideoDetail",
          component: frontVideoDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: false
          }
        },
        {
          // 点播详情-分享
          path: "/front/videoDetailFx",
          name: "frontVideoDetailFx",
          component: frontVideoDetailFx,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true
          }
        },
        {
          // 新闻公告详情
          path: "/front/newsDetail",
          name: "frontNewsDetail",
          component: frontNewsDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true,
            index: "6"
          }
        },
        {
          // 浏览更多
          path: "/front/loadMore",
          name: "frontLoadMore",
          component: frontLoadMore,
          meta: {
            keepAlive: true, // 需要缓存当前页面
            activePath: true
          }
        },
        {
          // 我的收藏--名师教研
          path: "/front/teacherCollect",
          name: "frontTeacherCollect",
          component: frontTeacherCollect,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: false
          }
        },
        {
          // 观看历史--名校课程
          path: "/front/videoHistor",
          name: "frontVideoHistory",
          component: frontVideoHistory,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true
          }
        },
        {
          // 在线听评课--PC分享页
          path: "/front/curriculumEvaluationFx",
          name: "frontCurriculumEvaluationFx",
          component: frontCurriculumEvaluationFx,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            activePath: true
          }
        }
      ]
    },
    {
    // 图书馆大数据服务平台
      path: "/libraryBigData",
      name: "libraryBigData",
      component: libraryBigData,
      meta: {
        keepAlive: true, // 不需要缓存当前页面
        activePath: false, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
    // 智慧校园应用概览
      path: "/smartSchool",
      name: "smartSchool",
      component: smartSchool,
      meta: {
        keepAlive: true, // 不需要缓存当前页面
        activePath: false, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
    // 智慧校园应用详情
      path: "/appliedStatistics",
      name: "appliedStatistics",
      component: appliedStatistics,
      meta: {
        keepAlive: true, // 不需要缓存当前页面
        activePath: false, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // 500
      path: "/500",
      name: "error",
      component: error,
      meta: {
        type: "error"
      }
    },
    {
      // loading
      path: "/loading",
      name: "loading",
      component: loading,
      meta: {
        type: "loading"
      }
    },
    {
      // 客户端嵌套学科网
      path: "/subject_network",
      name: "subject_network",
      component: subject_network,
      meta: {
        type: "adhoc"
        // keepAlive: false, // 不需要缓存当前页面
        // activePath: true, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
      // 注册页面嵌套 三个课堂平台、集控管理平台注册
      path: "/register",
      name: "register",
      component: register,
      meta: {
        type: "adhoc"
        // keepAlive: false, // 不需要缓存当前页面
        // activePath: true, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
      // 客户端嵌套状元网
      path: "/wx_mfzy",
      name: "wx_mfzy",
      component: wx_mfzy,
      meta: {
        type: "adhoc"
        // keepAlive: false, // 不需要缓存当前页面
        // activePath: true, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
      // 客户端嵌套21世纪
      path: "/wx_century21",
      name: "wx_century21",
      component: wx_century21,
      meta: {
        type: "adhoc"
        // keepAlive: false, // 不需要缓存当前页面
        // activePath: true, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
      // 客户端嵌套资源
      path: "/wxResourceAll",
      name: "wxResourceAll",
      component: wxResourceAll,
      meta: {
        type: "adhoc"
        // keepAlive: false, // 不需要缓存当前页面
        // activePath: true, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
      // 客户端嵌套状元网展示视频
      path: "/wx_mfzy_video",
      name: "wx_mfzy_video",
      component: wx_mfzy_video,
      meta: {
        type: "adhoc"
        // keepAlive: false, // 不需要缓存当前页面
        // activePath: true, // 无token状态下，是否可以访问。(前台专属)
      }
    },
    {
      // 缺省页
      path: "/wwh",
      name: "wwh",
      component: wwh
    },
    {
      // 抽签
      path: "/drawlots",
      name: "drawlots",
      component: drawlots,
      meta: {
        keepAlive: false, // 不需要缓存当前页面
        rank: 2,
        type: "adhoc"
      }
    },
    // 查看考试试卷详情
    {
      path: "/detail_Educational",
      name: "detail_Educational",
      component: detail_Educational,
      meta: {
        keepAlive: false, // 不需要缓存当前页面
        rank: 2,
        type: "adhoc"
      }
    },
    {
      // 距离最近一次考试倒计时
      path: "/countdown",
      name: "countdown",
      component: countdown,
      meta: {
        keepAlive: false, // 不需要缓存当前页面
        rank: 2,
        type: "adhoc"
      }
    },
    {
      //开始考试
      path: "/The_exam_will_begin",
      name: "The_exam_will_begin",
      component: The_exam_will_begin,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 实验考试
      path: "/test",
      name: "test",
      component: test,
      meta: {
        type: "adhoc"
      }
    },
    {
      //个人报告详情
      path: "/Individualreport",
      name: "Individualreport",
      component: Individualreport,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 班级报告详情
      path: "/Theclassreport",
      name: "Theclassreport",
      component: Theclassreport,
      meta: {
        type: "adhoc"
      }
    },
    // 组页面默认页面
    {
      path: "/group",
      name: "group",
      component: home,
      redirect: "/group/educationalInfo",
      children: [
        {
          // 前台管理
          path: "/group/frontAdmin",
          name: "frontAdmin",
          component: frontAdmin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "frontAdmin" // 归属父级页面
          }
        },
        {
          // 私有化-前台管理
          path: "/group/frontAdminPrivate",
          name: "frontAdminPrivate",
          component: frontAdminPrivate,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "frontAdminPrivate" // 归属父级页面
          }
        },
        {
          // 404
          path: "/404",
          name: "faid",
          component: faid,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "faid" // 归属父级页面
          }
        },
        {
          // pad升级
          path: "/group/pad_upgrade_management",
          name: "pad_upgrade_management",
          component: pad_upgrade_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "pad_upgrade_management" // 归属父级页面
          }
        },
        {
          // pc升级
          path: "/group/pc_upgrade_management",
          name: "pc_upgrade_management",
          component: pc_upgrade_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "pc_upgrade_management" // 归属父级页面
          }
        },
        {
          // 固件升级
          path: "/group/firmware_upgrade_management",
          name: "firmware_upgrade_management",
          component: firmware_upgrade_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "firmware_upgrade_management" // 归属父级页面
          }
        },
        //
        {
          // 考试管理
          path: "/group/exam_management",
          name: "exam_management",
          component: exam_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 准考证
          path: "/group/exam_card",
          name: "exam_card",
          component: exam_card,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 考场人员分配信息
          path: "/group/exam_people",
          name: "exam_people",
          component: exam_people,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 新增考场信息
          path: "/group/examination_detail",
          name: "examination_detail",
          component: examination_detail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: "exam",
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 新增考场信息
          path: "/group/exam_set",
          name: "exam_set",
          component: exam_set,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 考生设置
          path: "/group/exam_handlestudent",
          name: "exam_handlestudent",
          component: exam_handlestudent,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 阅卷人员设置
          path: "/group/exam_handleteacher",
          name: "exam_handleteacher",
          component: exam_handleteacher,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 视频阅卷
          path: "/group/exam_reviews",
          name: "exam_reviews",
          component: exam_reviews,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 视频阅卷
          path: "/group/exam_line_reviews",
          name: "exam_line_reviews",
          component: exam_line_reviews,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 实验考试（考生、阅卷、监考人员选择）
          path: "/group/experiment_peopele",
          name: "experiment_peopele",
          component: experiment_peopele,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "exam_management" // 归属父级页面
          }
        },
        {
          // 争议仲裁-列表
          path: "/group/dispute_arbitration",
          name: "dispute_arbitration",
          component: dispute_arbitration,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "dispute_arbitration" // 归属父级页面
          }
        },
        {
          // 争议仲裁-处理
          path: "/group/stay_dispose",
          name: "stay_dispose",
          component: stay_dispose,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "dispute_arbitration" // 归属父级页面
          }
        },
        {
          // 争议仲裁-阅卷人员选择
          path: "/group/stay_exam_reviews",
          name: "stay_exam_reviews",
          component: stay_exam_reviews,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "dispute_arbitration" // 归属父级页面
          }
        },
        {
          // 争议仲裁-阅卷
          path: "/group/stay_arbitration_exam_reviews",
          name: "stay_arbitration_exam_reviews",
          component: stay_arbitration_exam_reviews,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "dispute_arbitration" // 归属父级页面
          }
        },
        {
          // 争议仲裁结果
          path: "/group/stay_arbitration_exam_result",
          name: "stay_arbitration_exam_result",
          component: stay_arbitration_exam_result,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "dispute_arbitration" // 归属父级页面
          }
        },
        {
          // 仲裁阅卷
          path: "/group/stay_arbitration_reviews",
          name: "stay_arbitration_reviews",
          component: stay_arbitration_reviews,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "stay_arbitration_reviews" // 归属父级页面
          }
        },
        {
          // 个人中心
          path: "/group/personal",
          name: "personal",
          component: personal,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "user", // 归属父级页面
            index: "9"
          }
        },
        {
          // 概览
          path: "/group/probable",
          name: "probable",
          component: probable,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "probable" // 归属父级页面
          }
        },
        {
          // 账号管理页面
          path: "/group/account",
          name: "account",
          component: account,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "account" // 归属父级页面
          }
        },
        {
          // 账号管查看账号权限
          path: "/group/viewJurisdiction",
          name: "viewJurisdiction",
          component: viewJurisdiction,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "account" // 归属父级页面
          }
        },
        {
          // 账号管理新增
          path: "/group/addaccount",
          name: "addaccount",
          component: addaccount,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "account" // 归属父级页面
          }
        },
        {
          // 账号管理导入
          path: "/group/importtemplate",
          name: "importtemplate",
          component: importtemplate,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "account" // 归属父级页面
          }
        },
        {
          // 超管 菜单更新管理
          path: "/group/menuUpdate",
          name: "menuUpdate",
          component: menuUpdate,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "menuUpdate" // 归属父级页面
          }
        },
        {
          // 超管 菜单更新管理
          path: "/group/whiteList",
          name: "whiteList",
          component: whiteList,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "whiteList" // 归属父级页面
          }
        },
        {
          // 设备类型
          path: "/group/equipment",
          name: "equipment",
          component: equipment,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "equipment" // 归属父级页面
          }
        },
        {
          // 设备管理（云平台）
          path: "/group/managementguanli",
          name: "managementguanli",
          component: managementguanli,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 设备组管理
          path: "/group/deviceList",
          name: "deviceList",
          component: deviceList,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "deviceList" // 归属父级页面
          }
        },
        {
          // 添加设备组
          path: "/group/addDeviceGroup",
          name: "addDeviceGroup",
          component: addDeviceGroup,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "deviceList" // 归属父级页面
          }
        },
        {
          // 班级设备列表
          path: "/group/class_device_list",
          name: "class_device_list",
          component: class_device_list,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 软件库
          path: "/group/software-list",
          name: "software-list",
          component: software_list,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 集控第三方应用管理
          path: "/group/third-app",
          name: "third-app",
          component: third_app,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        // 学习平板 设置
        {
          path: "/group/stduy_pad",
          name: "stduy_pad",
          component: stduy_pad,
          meta: {
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          },
          children: [
            {
              // 时间
              path: "/group/stduy_pad_time",
              name: "stduy_pad_time",
              component: stduy_pad_time,
              meta: {
                keepAlive: false, // 不需要缓存当前页面
                rank: 2,
                attribution: "managementguanli" // 归属父级页面
              }
            },
            {
              // 护眼
              path: "/group/stduy_pad_eyeshield",
              name: "stduy_pad_eyeshield",
              component: stduy_pad_eyeshield,
              meta: {
                keepAlive: false, // 不需要缓存当前页面
                rank: 2,
                attribution: "managementguanli" // 归属父级页面
              }
            },
            {
              // 应用
              path: "/group/stduy_pad_apply",
              name: "stduy_pad_apply",
              component: stduy_pad_apply,
              meta: {
                keepAlive: false, // 不需要缓存当前页面
                rank: 2,
                attribution: "managementguanli" // 归属父级页面
              }
            },
            {
              // 网络
              path: "/group/stduy_pad_network",
              name: "stduy_pad_network",
              component: stduy_pad_network,
              meta: {
                keepAlive: false, // 不需要缓存当前页面{
                rank: 2,
                attribution: "managementguanli" // 归属父级页面
              }
            },
            {
              // 基础设置
              path: "/group/stduy_pad_basics",
              name: "stduy_pad_basics",
              component: stduy_pad_basics,
              meta: {
                keepAlive: false, // 不需要缓存当前页面
                rank: 2,
                attribution: "managementguanli" // 归属父级页面
              }
            }
          ]
        },
        {
          // 桌面预览
          path: "/group/wx_review",
          name: "wx_preview",
          component: wx_preview,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 录播预览
          path: "/group/wx_previewa",
          name: "wx_previewa",
          component: wx_previewa,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 打铃设置
          path: "/group/wx_jow",
          name: "wx_jow",
          component: wx_jow,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 信息发布
          path: "/group/wx_information_publish",
          name: "wx_information_publish",
          component: wx_information_publish,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 信息发布
          path: "/group/wx_information_add",
          name: "wx_information_add",
          component: wx_information_add,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 计划任务
          path: "/group/wx_scheduled_task",
          name: "wx_scheduled_task",
          component: wx_scheduled_task,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 计划任务
          path: "/group/wx_scheduled_add",
          name: "wx_scheduled_add",
          component: wx_scheduled_add,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 文件推送
          path: "/group/FileToPush",
          name: "FileToPush",
          component: FileToPush,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 文件推送 新增
          path: "/group/addfile",
          name: "addfile",
          component: addfile,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "managementguanli" // 归属父级页面
          }
        },
        {
          // 线上应用
          path: "/group/onlinelist",
          name: "onlinelist",
          component: onlinelist,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "onlinelist" // 归属父级页面
          }
        },
        {
          // 版本管理
          path: "/group/appmanager",
          name: "appmanager",
          component: appmanager,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "appmanager" // 归属父级页面
          }
        },
        {
          // 综合设置
          path: "/group/setting",
          name: "setting",
          component: setting,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "setting" // 归属父级页面
          }
        },
        // 教务巡课
        {
          path: "/group/online_tour_class",
          name: "patro",
          component: patro,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "online_tour_class" // 归属父级页面
          }
        },
        // 教务巡课 --- 巡课记录 --- 详情
        {
          path: "/group/patroJldetail",
          name: "patroJldetail",
          component: patroJldetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "online_tour_class" // 归属父级页面
          }
        },
        // 服务器数据
        {
          path: "/group/serverData",
          name: "serverData",
          component: serverData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "serverData" // 归属父级页面
          }
        },
        // 服务器数据
        {
          path: "/group/serverDataView",
          name: "serverDataView",
          component: serverDataView,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "serverData" // 归属父级页面
          }
        },
        // 智慧教室列表
        {
          path: "/group/teamModelList",
          name: "teamModelList",
          component: teamModelList,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "teamModelList" // 归属父级页面
          }
        },
        // 智慧教室控制
        {
          path: "/group/teamModelControl",
          name: "teamModelControl",
          component: teamModelControl,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "teamModelList" // 归属父级页面
          }
        },
        {
          // 子服务管理
          path: "/group/subserver",
          name: "subserver",
          component: subserver,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "subserver" // 归属父级页面
          }
        },
        // 巡课分组
        {
          path: "/group/patrolGroupingList",
          name: "patrolGroupingList",
          component: patrolGroupingList,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "patrolGroupingList" // 归属父级页面
          }
        },
        {
          // 添加巡课组
          path: "/group/addPatrolGroup",
          name: "addPatrolGroup",
          component: addPatrolGroup,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "patrolGroupingList" // 归属父级页面
          }
        },
        {
          // 公告管理
          path: "/group/bulletinAdmin",
          name: "bulletinAdmin",
          component: bulletinAdmin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "bulletinAdmin" // 归属父级页面
          }
        },
        {
          // 新增公告
          path: "/group/bulletinAdd",
          name: "bulletinAdd",
          component: bulletinAdd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "bulletinAdmin" // 归属父级页面
          }
        },
        // ------------------------------
        {
          // 巡逻首页
          path: "/group/onlinePatrolClass",
          name: "onlinePatrolClass",
          component: onlinePatrolClass,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "onlinePatrolClass" // 归属父级页面
          }
        },
        {
          // 在线巡课
          path: "/group/cruiseLessonVideo",
          name: "cruiseLessonVideo",
          component: cruiseLessonVideo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "onlinePatrolClass" // 归属父级页面
          }
        },
        {
          // 在线巡课-视频文件
          path: "/group/cruiseLessonFile",
          name: "cruiseLessonFile",
          component: cruiseLessonFile,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "onlinePatrolClass" // 归属父级页面
          }
        },
        {
          // 远程控制
          path: "/group/theremotecontrol",
          name: "theremotecontrol",
          component: theremotecontrol,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "" // 归属父级页面
          },
        },
        //-----------------------------------------------
        //-------------------------教育路由---------------
        //-----------------------------------------------
        {
          // 系统升级
          path: "/group/system",
          name: "system",
          component: system,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "system" // 归属父级页面
          }
        },
        {
          // 系统升级设备详情
          path: "/group/equipmentdetails",
          name: "equipmentdetails",
          component: equipmentdetails,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "system" // 归属父级页面
          }
        },
        // {
        //   // 充值
        //   path: "/group/money",
        //   name: "money",
        //   component: money,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 1,
        //     attribution: "money" // 归属父级页面
        //   }
        // },
        // {
        //   // 确认订单 不开发票
        //   path: "/group/affirm",
        //   name: "affirm",
        //   component: affirm,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 2,
        //     attribution: "money" // 归属父级页面
        //   }
        // },
        // {
        //   // 续费
        //   path: "/group/renew",
        //   name: "renew",
        //   component: renew,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 2,
        //     attribution: "money" // 归属父级页面
        //   }
        // },
        // {
        //   // 购买
        //   path: "/group/purchase",
        //   name: "purchase",
        //   component: purchase,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 2,
        //     attribution: "money" // 归属父级页面
        //   }
        // },
        // {
        //   // 订单记录
        //   path: "/group/OrderRecord",
        //   name: "orderrecord",
        //   component: orderrecord,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 1,
        //     attribution: "orderrecord" // 归属父级页面
        //   }
        // },
        {
          // 设备位置管理
          path: "/group/SiteManagement",
          name: "sitemanagement",
          component: sitemanagement,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "sitemanagement" // 归属父级页面
          }
        },
        {
          // 查看设备位置绑定的设备页面
          path: "/group/sitemanagementxq",
          name: "sitemanagementxq",
          component: sitemanagementxq,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "sitemanagement" // 归属父级页面
          }
        },
        //-----------------------------------------------
        //-----------------------------------------------
        //-----------------------------------------------
        {
          // 角色管理
          path: "/group/role",
          name: "role",
          component: role,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "role" // 归属父级页面
          }
        },
        // 自动登录
        {
          path: "/group/automaticLogin",
          name: "automaticLogin",
          component: automaticLogin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "automaticLogin" // 归属父级页面
          }
        },
        {
          // 角色新增
          path: "/group/addrolePermission",
          name: "addrolePermission",
          component: addrolePermission,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "role" // 归属父级页面
          }
        },
        {
          // 角色管理权限配置
          path: "/group/editrole",
          name: "editrole",
          component: editrole,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "role" // 归属父级页面
          }
        },
        {
          // 意见反馈
          path: "/group/feedback",
          name: "feedback",
          component: feedback,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "feedback" // 归属父级页面
          }
        },
        // { // 意见反馈详情
        //     path: '/group/particulars',
        //     name: 'particulars',
        //     component: particulars,
        //     meta: {
        //         keepAlive: false, // 不需要缓存当前页面
        //         rank: 2,
        //         attribution: 'feedback' // 归属父级页面
        //     },
        // },
        {
          // 意见反馈用户
          path: "/group/suggestion",
          name: "suggestion",
          component: suggestion,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "feedback" // 归属父级页面
          }
        },
        {
          // 操作记录
          path: "/group/operation",
          name: "operation",
          component: operation,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "operation" // 归属父级页面
          }
        },
        {
          // 异常日志
          path: "/group/abnormal",
          name: "abnormal",
          component: abnormal,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "abnormal" // 归属父级页面
          }
        },
        {
          // 异常日志/操作记录 详情
          path: "/group/abnormalxq",
          name: "abnormalxq",
          component: abnormalxq,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "abnormal" // 归属父级页面
          }
        },
        {
          // 后台日志
          path: "/group/hotaiTheLog",
          name: "hotaithelog",
          component: hotaithelog,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "hotaithelog" // 归属父级页面
          }
        },
        {
          // 登录日志
          path: "/group/loginLog",
          name: "loginlog",
          component: loginlog,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "loginlog" // 归属父级页面
          }
        },
        {
          // 产品管理
          path: "/group/productManagement",
          name: "productManagement",
          component: productManagement,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "productManagement" // 归属父级页面
          }
        },
        {
          // 产品管理--授权
          path: "/group/authorization",
          name: "authorization",
          component: authorization,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "productManagement" // 归属父级页面
          }
        },
        {
          // 区域或学校未授权界面
          path: "/group/TheDominant",
          name: "TheDominant",
          component: TheDominant,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "TheDominant" // 归属父级页面
          }
        },
        {
          // 区域授权--授权账号
          path: "/group/cancel_account",
          name: "cancel_account",
          component: cancel_account,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "TheDominant" // 归属父级页面
          }
        },
        {
          // 教学 演示资源
          path: "/group/demonst",
          name: "demonst",
          component: demo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "demonst" // 归属父级页面
          }
        },
        {
          // 演示资源 添加修改
          path: "/group/demoadd",
          name: "demoadd",
          component: demoadd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "demonst", // 归属父级页面
            attributions: "demonst" // 返回指定页面
          }
        },
        {
          // 课堂练习
          path: "/group/classroom",
          name: "classroom",
          component: classroom,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "classroom" // 归属父级页面
          }
        },
        {
          // 云资源
          path: "/group/cloudres",
          name: "cloudres",
          component: cloudres,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "cloudres" // 归属父级页面
          }
        },
        {
          // 录制视频资源
          path: "/group/commonResource",
          name: "commonResource",
          component: commonResource,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "commonResource" // 归属父级页面
          }
        },
        {
          // 录制视频资源详情
          path: "/group/commonResourceInfo",
          name: "commonResourceInfo",
          component: commonResourceInfo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "commonResource" // 归属父级页面
          }
        },
        {
          // 课堂练习 添加修改
          path: "/group/classroomadd",
          name: "classroomadd",
          component: classroomadd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "classroom", // 归属父级页面
            attributions: "classroom" // 归属父级页面
          }
        },
        {
          // 学情分析
          path: "/group/studentAnalysis",
          name: "studentAnalysis",
          component: studentAnalysis,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "studentAnalysis" // 归属父级页面
          }
        },
        {
          // 学情分析-个人表现
          path: "/group/personageManifestation",
          name: "personageManifestation",
          component: personageManifestation,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "studentAnalysis" // 归属父级页面
          }
        },
        {
          // 数据看板 超管
          path: "/group/SuperTube",
          name: "SuperTube",
          component: SuperTube,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "SuperTube" // 归属父级页面
          }
        },
        {
          // 学校管理
          path: "/group/management",
          name: "management",
          component: management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "management" // 归属父级页面
          }
        },
        // {
        //   // 套餐明细
        //   path: "/group/detail",
        //   name: "detail",
        //   component: detail,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 1,
        //     attribution: "management" // 归属父级页面
        //   }
        // },
        // {
        //   // 查看明细
        //   path: "/group/selectdetail",
        //   name: "selectdetail",
        //   component: selectdetail,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 2,
        //     attribution: "management" // 归属父级页面
        //   }
        // },
        {
          // 评价管理
          path: "/group/judge",
          name: "judge",
          component: judge,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "judge" // 归属父级页面
          }
        },
        {
          // 评论管理
          path: "/group/comment",
          name: "comment",
          component: comment,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "comment" // 归属父级页面
          }
        },
        {
          // 学校管理详情
          path: "/group/managementdetails",
          name: "managementdetails",
          component: managementdetails,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "management" // 归属父级页面
          }
        },
        {
          // 学制管理
          path: "/group/systemmanagement",
          name: "systemmanagement",
          component: systemmanagement,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "systemmanagement" // 归属父级页面
          }
        },
        {
          // 班级详情
          path: "/group/classdetails",
          name: "classdetails",
          component: classdetails,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "classandgrade" // 归属父级页面
          }
        },
        {
          // 班级列表
          path: "/group/theclasslist",
          name: "theclasslist",
          component: theclasslist,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "theclasslist" // 归属父级页面
          }
        },
        {
          // 班级分组详情
          path: "/group/groupingList",
          name: "groupingList",
          component: groupingList,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "theclasslist" // 归属父级页面
          }
        },
        {
          // 分组
          path: "/group/studentGrouping",
          name: "studentGrouping",
          component: studentGrouping,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "theclasslist" // 归属父级页面
          }
        },
        // {
        //   // 序列号管理
        //   path: "/group/serialnumber",
        //   name: "serialnumber",
        //   component: serialnumber,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 1,
        //     attribution: "serialnumber" // 归属父级页面
        //   }
        // },
        // {
        //   // 序列号新增
        //   path: "/group/detailpagenumber",
        //   name: "detailpagenumber",
        //   component: detailpagenumber,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 2,
        //     attribution: "serialnumber" // 归属父级页面
        //   }
        // },
        // {
        //   // 套餐管理 个人
        //   path: "/group/personalGr",
        //   name: "personalGr",
        //   component: personalGr,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 2,
        //     attribution: "personalGr" // 归属父级页面
        //   }
        // },
        // {
        //   // 套餐管理 集体
        //   path: "/group/thecollective",
        //   name: "thecollective",
        //   component: thecollective,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 2,
        //     attribution: "thecollective" // 归属父级页面
        //   }
        // },
        // {
        //   // 我的套餐
        //   path: "/group/mypackage",
        //   name: "mypackage",
        //   component: mypackage,
        //   meta: {
        //     keepAlive: false, // 不需要缓存当前页面
        //     rank: 1,
        //     attribution: "mypackage" // 归属父级页面
        //   }
        // },
        // 资产管理 - 校管
        {
          // 教学楼-管理
          path: "/group/ZCGL_jiaoxuelou",
          name: "ZCGL_jiaoxuelou",
          component: ZCGL_jiaoxuelou,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "ZCGL_jiaoxuelou" // 归属父级页面
          }
        },
        {
          // 教室-管理
          path: "/group/ZCGL_jiaoshi",
          name: "ZCGL_jiaoshi",
          component: ZCGL_jiaoshi,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "ZCGL_jiaoshi" // 归属父级页面
          }
        },
        {
          // 教室-新增
          path: "/group/ZCGL_jiaoshiadd",
          name: "ZCGL_jiaoshiadd",
          component: ZCGL_jiaoshiadd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "ZCGL_jiaoshi" // 归属父级页面
          }
        },
        {
          // 教室-导入
          path: "/group/ZCGL_import",
          name: "ZCGL_import",
          component: ZCGL_import,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "ZCGL_jiaoshi" // 归属父级页面
          }
        },
        {
          // 实验室管理
          path: "/group/laboratory",
          name: "laboratory",
          component: laboratory,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "laboratory" // 归属父级页面
          }
        },
        {
          // 实验室管理（新增）
          path: "/group/laboratoryadd",
          name: "laboratoryadd",
          component: laboratoryadd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "laboratory" // 归属父级页面
          }
        },
        {
          // 设备-管理
          path: "/group/ZCGL_shebei",
          name: "ZCGL_shebei",
          component: ZCGL_shebei,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "ZCGL_shebei" // 归属父级页面
          }
        },

        {
          // 设备管理 交互大屏 使用情况
          path: "/group/serviceCondition",
          name: "serviceCondition",
          component: serviceCondition,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "ZCGL_shebei" // 归属父级页面
          }
        },
        {
          // 网络摄像机(新增)
          path: "/group/Wxebcam",
          name: "Wxebcam",
          component: Wxebcam,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "ZCGL_shebei" // 归属父级页面
          }
        },
        {
          // 年级-管理
          path: "/group/XZGL_nj",
          name: "XZGL_nj",
          component: XZGL_nj,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "XZGL_nj" // 归属父级页面
          }
        },
        {
          // 学科-管理
          path: "/group/XZGL_xk",
          name: "XZGL_xk",
          component: XZGL_xk,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "XZGL_xk" // 归属父级页面
          }
        },
        {
          // 学段管理
          path: "/group/wx_learning_period",
          name: "wx_learning_period",
          component: wx_learning_period,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_learning_period" // 归属父级页面
          }
        },
        {
          // 今日整体数据看板
          path: "/group/todayDataBlackboard",
          name: "todayDataBlackboard",
          component: todayDataBlackboard,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "todayDataBlackboard" // 归属父级页面
          }
        },
        {
          // 班级数据看板
          path: "/group/classDataBlackboard",
          name: "classDataBlackboard",
          component: classDataBlackboard,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "classDataBlackboard" // 归属父级页面
          }
        },
        {
          // 教师数据看板
          path: "/group/teacherDataBlackboard",
          name: "teacherDataBlackboard",
          component: teacherDataBlackboard,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "teacherDataBlackboard" // 归属父级页面
          }
        },
        {
          // 学生数据看板
          path: "/group/studentDataBlackboard",
          name: "studentDataBlackboard",
          component: studentDataBlackboard,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "studentDataBlackboard" // 归属父级页面
          }
        },
        {
          // AI课堂
          path: "/group/analysisresult",
          name: "analysisresult",
          component: analysisresult,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "analysisresult" // 归属父级页面
          }
        },
        {
          // AI课堂-二阶段
          path: "/group/aiClassroom",
          name: "aiClassroom",
          component: aiClassroom,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiClassroom" // 归属父级页面
          }
        },
        {
          // AI课堂-数据总览
          path: "/group/dataOverview",
          name: "dataOverview",
          component: dataOverview,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "aiClassroom" // 归属父级页面
          }
        },
        {
          // AI课堂-对比分析
          path: "/group/dataComparison",
          name: "dataComparison",
          component: dataComparison,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "dataComparison" // 归属父级页面
          }
        },
        {
          // AI课堂-AI分析
          path: "/group/aiDetail",
          name: "aiDetail",
          component: aiDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "aiClassroom" // 归属父级页面
          }
        },
        {
          // AI监考
          path: "/group/aiInvigilate",
          name: "aiInvigilate",
          component: aiInvigilate,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiInvigilate" // 归属父级页面
          }
        },
        {
          // AI分析详情页面
          path: "/group/aiInvigilateDetail",
          name: "aiInvigilateDetail",
          component: aiInvigilateDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiInvigilateDetail" // 归属父级页面
          }
        },
        {
          // AI监考通知预警
          path: "/group/aiInvigilateAlarm",
          name: "aiInvigilateAlarm",
          component: aiInvigilateAlarm,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "aiInvigilate" // 归属父级页面
          }
        },
        {
          // AI考勤
          path: "/group/aiAttendance",
          name: "aiAttendance",
          component: aiAttendance,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiAttendance" // 归属父级页面
          }
        },
        {
          // AI考勤-超管
          path: "/group/aiAttendanceAdmin",
          name: "aiAttendanceAdmin",
          component: aiAttendanceAdmin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiAttendanceAdmin" // 归属父级页面
          }
        },
        {
          // AI考勤-区管
          path: "/group/aiAttendanceGovernor",
          name: "aiAttendanceGovernor",
          component: aiAttendanceGovernor,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiAttendanceGovernor" // 归属父级页面
          }
        },
        {
          // AI考勤-校管
          path: "/group/aiAttendancePrincipal",
          name: "aiAttendancePrincipal",
          component: aiAttendancePrincipal,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiAttendancePrincipal" // 归属父级页面
          }
        },
        {
          // AI考勤-详情页面
          path: "/group/aiAttendanceGrade",
          name: "aiAttendanceGrade",
          component: aiAttendanceGrade,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "aiAttendancePrincipal" // 归属父级页面
          }
        },
        {
          // AI考勤-校级管理员班级列表、教师智能考勤默认页面（课程）
          path: "/group/aiAttendanceCourse",
          name: "aiAttendanceCourse",
          component: aiAttendanceCourse,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiAttendanceCourse" // 归属父级页面
          }
        },
        {
          // 服务管理
          path: "/group/aiServerManager",
          name: "aiServerManager",
          component: aiServerManager,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiServerManager" // 归属父级页面
          }
        },
        {
          // 高级设置
          path: "/group/aiSetConfig",
          name: "aiSetConfig",
          component: aiSetConfig,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "aiSetConfig" // 归属父级页面
          }
        },
        {
          // AI课堂-查看分析结果
          path: "/group/analysisresultresult",
          name: "analysisresultresult",
          component: analysisresultresult,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "analysisresult" // 归属父级页面
          }
        },
        {
          // 设备巡视
          path: "/group/lookpatrol",
          name: "lookpatrol",
          component: lookpatrol,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "lookpatrol" // 归属父级页面
          }
        },
        {
          // 人脸库
          path: "/group/importPhotos",
          name: "importPhotos",
          component: importPhotos,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "importPhotos" // 归属父级页面
          }
        },
        {
          // 设置-服务器IP
          path: "/group/serverInfo",
          name: "serverInfo",
          component: serverInfo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "serverInfo" // 归属父级页面
          }
        },
        {
          // 设备管理（云平台-表格版）
          path: "/group/managementguanlitable",
          name: "managementguanlitable",
          component: managementguanlitable,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "managementguanlitable" // 归属父级页面
          }
        },
        {
          // 关联-管理 学校
          path: "/group/Gwx_associated_guanli",
          name: "wx_associated_guanli",
          component: wx_associated_guanli,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_associated_guanli" // 归属父级页面
          }
        },
        {
          // 关联-管理 学校
          path: "/group/wx_assicuated_add",
          name: "wx_assicuated_add",
          component: wx_assicuated_add,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_associated_admin" // 归属父级页面
          }
        },
        {
          // 关联-管理 区域
          path: "/group/wx_associated_area",
          name: "wx_associated_area",
          component: wx_associated_rea,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_associated_area" // 归属父级页面
          }
        },
        {
          // 关联-管理-新增 区域
          path: "/group/wx_associated_business",
          name: "wx_associated_business",
          component: wx_associated_business,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_associated_admin" // 归属父级页面
          }
        },
        {
          // 关联-管理 区域创建
          path: "/group/create_area_relevance",
          name: "create_area_relevance",
          component: create_area_relevance,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_associated_admin" // 归属父级页面
          }
        },
        {
          // 业务-管理 区域
          path: "/group/wx_business",
          name: "wx_business",
          component: wx_business,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_business" // 归属父级页面
          }
        },
        {
          // 关联-管理 超管
          path: "/group/wx_associated_admin",
          name: "wx_associated_admin",
          component: wx_associated_admin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_associated_admin" // 归属父级页面
          }
        },
        {
          // 关联-管理 关联班级
          path: "/group/wx_associated_school",
          name: "wx_associated_school",
          component: wx_associated_school,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_associated_admin" // 归属父级页面
          }
        },
        {
          // 关联-管理 添加 超管
          path: "/group/wx_add_associated_admin",
          name: "wx_add_associated_admin",
          component: wx_add_associated_admin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_associated_admin" // 归属父级页面
          }
        },
        {
          // 区域-管理 超管
          path: "/group/wx_district_management",
          name: "wx_district_management",
          component: wx_district_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_district_management" // 归属父级页面
          }
        },
        {
          // 区域新增-管理 超管
          path: "/group/wx_district_add",
          name: "wx_district_add",
          component: wx_district_add,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_district_management" // 归属父级页面
          }
        },
        {
          // 高级管理
          path: "/group/wxSeniorManagement",
          name: "wxSeniorManagement",
          component: wxSeniorManagement,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wxSeniorManagement" // 归属父级页面
          }
        },
        {
          // 我的班级
          path: "/group/classandgrade",
          name: "classandgrade",
          component: classandgrade,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "classandgrade" // 归属父级页面
          }
        },
        {
          //家长管理
          path: "/group/patriarch",
          name: "patriarch",
          component: patriarch,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "patriarch" // 归属父级页面
          }
        },
        {
          //家长个人中心
          path: "/group/personalPatriarch",
          name: "personalPatriarch",
          component: personalPatriarch,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "personalPatriarch" // 归属父级页面
          }
        },
        {
          //课程管理
          path: "/group/course_management",
          name: "course_management",
          component: wx_course_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "course_management" // 归属父级页面
          }
        },
        {
          //课程管理
          path: "/group/import_data",
          name: "import_data",
          component: import_data,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "course_management" // 归属父级页面
          }
        },
        {
          //课程管理 (新增 或 修改)
          path: "/group/add_course",
          name: "add_course",
          component: add_course,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "course_management" // 归属父级页面
          }
        },
        {
          //教师管理
          path: "/group/teachermanage",
          name: "teachermanage",
          component: teachermanage,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "teachermanage" // 归属父级页面
          }
        },
        {
          // 添加教师
          path: "/group/addteacher",
          name: "addteacher",
          component: addteacher,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "teachermanage" // 归属父级页面
          }
        },
        {
          // 导出教师列表
          path: "/group/teacherimpot",
          name: "teacherimpot",
          component: teacherimpot,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "teachermanage" // 归属父级页面
          }
        },
        {
          //班级管理
          path: "/group/classmanage",
          name: "classmanage",
          component: classmanage,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "classmanage" // 归属父级页面
          }
        },
        {
          // 添加班级
          path: "/group/addclass",
          name: "addclass",
          component: addclass,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "classmanage" // 归属父级页面
          }
        },
        {
          // 导出班级列表
          path: "/group/classimpot",
          name: "classimpot",
          component: classimpot,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "classmanage" // 归属父级页面
          }
        },
        {
          //学生管理
          path: "/group/pupilmanage",
          name: "pupilmanage",
          component: pupilmanage,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "pupilmanage" // 归属父级页面
          }
        },
        {
          // 添加学生
          path: "/group/addpupil",
          name: "addpupil",
          component: addpupil,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "pupilmanage" // 归属父级页面
          }
        },
        {
          // 导出学生列表
          path: "/group/pupilimpot",
          name: "pupilimpot",
          component: pupilimpot,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "pupilmanage" // 归属父级页面
          }
        },
        {
          // 学期校历管理
          path: "/group/semester_calendar",
          name: "semester_calendar",
          component: wx_semester_calendar,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "semester_calendar" // 归属父级页面
          }
        },
        {
          //学期新增
          path: "/group/semester",
          name: "semester",
          component: semester,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: "semester",
            attribution: "semester_calendar" // 归属父级页面
          }
        },
        {
          // 校历设置
          path: "/group/calendar",
          name: "calendar",
          component: calendar,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: "semester",
            attribution: "semester_calendar" // 归属父级页面
          }
        },
        {
          // 作息时间设置
          path: "/group/timetable",
          name: "timetable",
          component: timetable,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: "semester",
            attribution: "semester_calendar" // 归属父级页面
          }
        },
        {
          //教研组管理
          path: "/group/resmanage",
          name: "resmanage",
          component: resmanage,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "resmanage" // 归属父级页面
          }
        },
        {
          // 导出教研组列表
          path: "/group/resimpot",
          name: "resimpot",
          component: resimpot,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "resmanage" // 归属父级页面
          }
        },
        {
          // 排课
          path: "/group/scheduling",
          name: "scheduling",
          component: scheduling,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "scheduling" // 归属父级页面
          }
        },
        {
          // 新增排课
          path: "/group/addscheduling",
          name: "addscheduling",
          component: addscheduling,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 指定页面
          path: "/group/assign",
          name: "assign",
          component: assign,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 指定教师页面
          path: "/group/assignTeacher",
          name: "assignTeacher",
          component: assignTeacher,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "assign" // 返回 指定页面
          }
        },
        {
          // 指定教室页面
          path: "/group/assignclassroomOut",
          name: "assignclassroomOut",
          component: assignclassroomOut,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 指定教室页面
          path: "/group/assignclassroom",
          name: "assignclassroom",
          component: assignclassroom,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "assignclassroomOut" // 返回 指定页面
          }
        },
        {
          // 合班
          path: "/group/combineclass",
          name: "combineclass",
          component: combineclass,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 禁排
          path: "/group/taboo",
          name: "taboo",
          component: taboo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 固排
          path: "/group/fixation",
          name: "fixation",
          component: fixation,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 排课结果
          path: "/group/result",
          name: "result",
          component: result,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 排课结果调课
          path: "/group/resultdebug",
          name: "resultdebug",
          component: resultdebug,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "result" // 返回 指定页面
          }
        },
        {
          // 手动排课
          path: "/group/manual",
          name: "manual",
          component: manual,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "scheduling", // 归属父级页面
            attributions: "scheduling" // 返回 指定页面
          }
        },
        {
          // 自动课表
          path: "/group/autoClassSchedule",
          name: "autoClassSchedule",
          component: autoClassSchedule,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "autoClassSchedule", // 归属父级页面
          }
        },
        {
          // 自动课表
          path: "/group/relevanceRoom",
          name: "relevanceRoom",
          component: relevanceRoom,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "autoClassSchedule", // 归属父级页面
          }
        },
        {
          // 调课
          path: "/group/switching",
          name: "switching",
          component: switching,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "switching" // 归属父级页面
          }
        },
        {
          // 调课 课表查询
          path: "/group/wx_curriculum",
          name: "wx_curriculum",
          component: wx_curriculum,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_curriculum" // 归属父级页面
          }
        },
        {
          // 课堂记录老师课堂记录
          path: "/group/class_register",
          name: "class_register",
          component: class_register,
          meta: {
            keepAlive: true, // 需要缓存当前页面
            rank: 1,
            attribution: "class_register" // 归属父级页面
          }
        },
        {
          // 课堂记录老师课堂记录详情
          path: "/group/record_details",
          name: "record_details",
          component: record_details,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "class_register" // 归属父级页面
          }
        },
        {
          // 课堂记录老师课堂记录详情
          path: "/group/student_view",
          name: "student_view",
          component: student_view,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "class_register" // 归属父级页面
          }
        },
        {
          // 课堂记录学生答题详情
          path: "/group/topic_perview",
          name: "topic_perview",
          component: topic_perview,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "class_register" // 归属父级页面
          }
        },
        {
          // 课堂记录学生分组详情
          path: "/group/grouping",
          name: "grouping",
          component: grouping,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "class_register" // 归属父级页面
          }
        },
        //-------------------录制视频资源--------------------------

        {
          // 手动录制视频资源
          path: "/group/video_Resources",
          name: "video_Resources",
          component: video_Resources,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "video_Resources" // 归属父级页面
          }
        },
        {
          // 手动视频资源详情
          path: "/group/video_Resources_info",
          name: "video_Resources_info",
          component: video_Resources_info,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "video_Resources" // 归属父级页面
          }
        },
        {
          // 自动录制
          path: "/group/commonResource",
          name: "commonResource",
          component: commonResource,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "commonResource" // 归属父级页面
          }
        },
        {
          // 自动录制资源详情
          path: "/group/commonResourceInfo",
          name: "commonResourceInfo",
          component: commonResourceInfo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "commonResource" // 归属父级页面
          }
        },
        // ------------------教学活动---------------------
        {
          // 课前预习
          path: "/group/preview",
          name: "preview",
          component: preview,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "preview" // 归属父级页面
          }
        },
        {
          // 课后任务
          path: "/group/task",
          name: "task",
          component: task,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "task" // 归属父级页面
          }
        },
        {
          // 发布预习
          path: "/group/release_preview",
          name: "release_preview",
          component: release_preview,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "preview" // 归属父级页面
          }
        },
        {
          // 预习详情
          path: "/group/reselease_detail",
          name: "reselease_detail",
          component: reselease_detail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "preview" // 归属父级页面
          }
        },
        {
          // 预习批改
          path: "/group/reselease_correction",
          name: "reselease_correction",
          component: reselease_correction,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "preview" // 归属父级页面
          }
        },
        {
          // 发布任务
          path: "/group/release_task",
          name: "release_task",
          component: release_task,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "task" // 归属父级页面
          }
        },
        {
          // 任务详情
          path: "/group/task_detail",
          name: "task_detail",
          component: task_detail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "task" // 归属父级页面
          }
        },
        {
          // 任务批改
          path: "/group/correction",
          name: "correction",
          component: correction,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "task" // 归属父级页面
          }
        },
        //----------------------账号审核--------------------
        {
          // 账号审核
          path: "/group/accountIInformation",
          name: "accountIInformation",
          component: accountIInformation,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "account" // 归属父级页面
          }
        },

        //----------------------档案管理--------------------
        {
          // 学生成长档案
          path: "/group/pupil_record",
          name: "pupil_record",
          component: pupil_record,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "pupil_record" // 归属父级页面
          }
        },
        {
          // 学生成长档案list
          path: "/group/pupil_record_list",
          name: "pupil_record_list",
          component: pupil_record_list,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "pupil_record" // 归属父级页面
          }
        },
        {
          // 学生成长档案class
          path: "/group/pupil_record_class",
          name: "pupil_record_class",
          component: pupil_record_class,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "pupil_record" // 归属父级页面
          }
        },
        {
          // 学生信息
          path: "/group/pupil_statistical",
          name: "pupil_statistical",
          component: pupil_statistical,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "pupil_record" // 归属父级页面
          }
        },
        {
          // 老师档案
          path: "/group/teacher_record",
          name: "teacher_record",
          component: teacher_record,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "teacher_record" // 归属父级页面
          }
        },
        {
          // 老师信息
          path: "/group/teacher_statistical",
          name: "teacher_statistical",
          component: teacher_statistical,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "teacher_statistical" // 归属父级页面
          }
        },
        {
          // 老师信息
          path: "/group/teacher_statistical_ret",
          name: "teacher_statistical_ret",
          component: teacher_statistical,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "teacher_statistical" // 归属父级页面
          }
        },
        //------------------------------------------
        //----------------------教研--------------------
        {
          // 教研室
          path: "/group/researchroom",
          name: "researchroom",
          component: researchroom,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 创建教研室
          path: "/group/addresearchroom",
          name: "addresearchroom",
          component: addresearchroom,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 教研室详情
          path: "/group/roomparticulars",
          name: "roomparticulars",
          component: roomparticulars,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "researchroom", // 归属父级页面
            attributions: "researchroom" // 返回指定页面
          }
        },
        {
          // 教研室更多
          path: "/group/roomevenOne",
          name: "roomevenOne",
          component: roomevenOne,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 教学研讨更多
          path: "/group/roomevenTwo",
          name: "roomevenTwo",
          component: roomevenTwo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 协同备课更多
          path: "/group/roomevenThree",
          name: "roomevenThree",
          component: roomevenThree,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 共享资料更多
          path: "/group/roomevenFour",
          name: "roomevenFour",
          component: roomevenFour,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 教研权限
          path: "/group/jurisdiction",
          name: "jurisdiction",
          component: jurisdiction,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 创建教研
          path: "/group/creatResearch",
          name: "creatResearch",
          component: creatResearch,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 创建备课
          path: "/group/creatlessons",
          name: "creatlessons",
          component: creatlessons,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 创建备课one
          path: "/group/onesetout",
          name: "onesetout",
          component: onesetout,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "researchroom", // 归属父级页面
            attributions: "roomparticulars" // 返回指定页面
          }
        },
        {
          // 创建备课two
          path: "/group/twofees",
          name: "twofees",
          component: twofees,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "researchroom", // 归属父级页面
            attributions: "roomparticulars" // 返回指定页面
          }
        },
        {
          // 创建备课 three
          path: "/group/threeupload",
          name: "threeupload",
          component: threeupload,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "researchroom", // 归属父级页面
            attributions: "roomparticulars" // 返回指定页面
          }
        },
        {
          // 创建备课 rethinkfour
          path: "/group/rethinkfour",
          name: "rethinkfour",
          component: rethinkfour,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "researchroom", // 归属父级页面
            attributions: "roomparticulars" // 返回指定页面
          }
        },
        {
          // 参与备课
          path: "/group/prepareResearch",
          name: "prepareResearch",
          component: prepareResearch,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 教研详情
          path: "/group/detailsResearch",
          name: "detailsResearch",
          component: detailsResearch,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "researchroom" // 归属父级页面
          }
        },
        {
          // 评比活动
          path: "/group/appraisal",
          name: "appraisal",
          component: appraisal,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "appraisal" // 归属父级页面
          }
        },
        {
          // 评比活动添加
          path: "/group/addappraisal",
          name: "addappraisal",
          component: addappraisal,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "appraisal" // 归属父级页面
          }
        },

        //----------------------成绩管理--------------------
        {
          // 成绩管理
          path: "/group/score_management",
          name: "score_management",
          component: score_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "score_management" // 归属父级页面
          }
        },
        {
          // 成绩新增
          path: "/group/score_importtemplate",
          name: "score_importtemplate",
          component: score_importtemplate,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "score_management" // 归属父级页面
          }
        },
        {
          // 成绩分析
          path: "/group/performance_analyse",
          name: "performance_analyse",
          component: performance_analyse,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "score_management" // 归属父级页面
          }
        },
        {
          // 区管成绩管理
          path: "/group/wx_areaOfTube_score",
          name: "wx_areaOfTube_score",
          component: wx_areaOfTube_score,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "wx_areaOfTube_score" // 归属父级页面
          }
        },
        {
          // 学校学生考试详情
          path: "/group/wx_areaOfTube_scoreDetail",
          name: "wx_areaOfTube_scoreDetail",
          component: wx_areaOfTube_scoreDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_areaOfTube_score" // 归属父级页面
          }
        },
        {
          // 区管查看学生成绩详情
          path: "/group/stundetScoreDetail",
          name: "stundetScoreDetail",
          component: stundetScoreDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "wx_areaOfTube_score" // 归属父级页面
          }
        },
        //------------------------------------------------------------

        //----------------------- 学生端路由 --------------------------
        // 课前预习
        {
          path: "/group/student_prepare",
          name: "student_prepare",
          component: student_prepare,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "student_prepare" // 归属父级页面
          }
        },
        {
          path: "/group/student_detail",
          name: "student_detail",
          component: student_detail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "student_prepare" // 归属父级页面
          }
        },
        // 课后任务
        {
          path: "/group/student_tasks",
          name: "student_tasks",
          component: student_tasks,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "student_tasks" // 归属父级页面
          }
        },
        // 课后任务详情
        {
          path: "/group/student_tasksdetail",
          name: "student_tasksdetail",
          component: student_tasksdetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "student_tasks" // 归属父级页面
          }
        },
        // 错题本
        {
          path: "/group/student_wrongtopic",
          name: "student_wrongtopic",
          component: student_wrongtopic,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "student_wrongtopic" // 归属父级页面
          }
        },
        // 错题重做
        {
          path: "/group/wrong_topic_redo",
          name: "wrong_topic_redo",
          component: wrong_topic_redo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "student_wrongtopic" // 归属父级页面
          }
        },
        // 课堂记录
        {
          path: "/group/student_classregister",
          name: "student_classregister",
          component: student_classregister,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "student_classregister" // 归属父级页面
          }
        },
        // 详情
        {
          path: "/group/studentRecord_particulars",
          name: "studentRecord_particulars",
          component: studentRecord_particulars,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "student_classregister" // 归属父级页面
          }
        },
        // 出题详情
        {
          path: "/group/write_the_details",
          name: "write_the_details",
          component: write_the_details,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "student_classregister" // 归属父级页面
          }
        },
        // 评价管理
        {
          path: "/group/evaluation_management",
          name: "evaluation_management",
          component: evaluation_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "evaluation_management" // 归属父级页面
          }
        },
        // 评价详情
        {
          path: "/group/evaluation_detail",
          name: "evaluation_detail",
          component: evaluation_detail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "evaluation_detail" // 归属父级页面
          }
        },
        //------------------------------------------------------------

        //----------------------- 考务 --------------------------
        // 试题库
        {
          path: "/group/testQuestions",
          name: "testQuestions",
          component: testQuestions,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "testQuestions" // 归属父级页面
          }
        },
        // 试题库-目录管理
        {
          path: "/group/catalogue",
          name: "catalogue",
          component: catalogue,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "testQuestions" // 归属父级页面
          }
        },
        // 试题库-新增试题
        {
          path: "/group/addQuestions",
          name: "addQuestions",
          component: addQuestions,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "testQuestions" // 归属父级页面
          }
        },
        // 试题库-上报
        {
          path: "/group/testQuestions_putIn",
          name: "testQuestions_putIn",
          component: testQuestions_putIn,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "testQuestions_putIn" // 归属父级页面
          }
        },
        // 试题库-审核
        {
          path: "/group/testQuestions_audit",
          name: "testQuestions_audit",
          component: testQuestions_putIn,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "testQuestions_audit" // 归属父级页面
          }
        },
         // 试卷库-目录管理
         {
          path: "/group/catalogue_testPaper",
          name: "catalogue",
          component: catalogue,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "testQuestions_testPaper" // 归属父级页面
          }
        },
        // 试卷库
        {
          path: "/group/testQuestions_testPaper",
          name: "testQuestions_testPaper",
          component: testQuestions_testPaper,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "testQuestions_testPaper" // 归属父级页面
          }
        },
         // 试卷库-上报
         {
          path: "/group/testQuestions_putIn_testPaper",
          name: "testQuestions_putIn_testPaper",
          component: testQuestions_putIn_testPaper,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "testQuestions_putIn_testPaper" // 归属父级页面
          }
        },
        // 试卷库-审核
        {
          path: "/group/testQuestions_testPaper_audit",
          name: "testQuestions_testPaper_audit",
          component: testQuestions_putIn_testPaper,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "testQuestions_testPaper_audit" // 归属父级页面
          }
        },
        // 组卷预览
        {
          path: "/group/combination",
          name: "combination",
          component: combination,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "testQuestions_testPaper" // 归属父级页面
          }
        },
        // 试卷详情
        {
          path: "/group/combinationInfo",
          name: "combinationInfo",
          component: combinationInfo,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "testQuestions_testPaper" // 归属父级页面
          }
        },
        // 智能组卷
        {
          path: "/group/combinationSmart",
          name: "combinationSmart",
          component: combinationSmart,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "testQuestions_testPaper" // 归属父级页面
          }
        },
        // 试卷管理
        {
          path: "/group/testPaper",
          name: "testPaper",
          component: testPaper,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "testPaper" // 归属父级页面
          }
        },
        {
          // 新增试卷
          path: "/group/addtestPaper",
          name: "addtestPaper",
          component: addtestPaper,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            // rank: '5c',
            rank: 1,
            attribution: "testPaper" // 归属父级页面
          }
        },
        //------------------------------------------------------------

        //----------------------- 考试 -------------------------------
        {
          // 列表
          path: "/group/examination",
          name: "examination",
          component: examination,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "examination" // 归属父级页面
          }
        },

        //----------------------- 课程 -------------------------------
        {
          // 课程审核
          path: "/group/curriculum_aduit",
          name: "curriculum_aduit",
          component: curriculum_aduit,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "curriculum_aduit" // 归属父级页面
          }
        },
        {
          // 审核
          path: "/group/aduit",
          name: "aduit",
          component: aduit,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "curriculum_aduit" // 归属父级页面
          }
        },
        {
          // 预览
          path: "/group/aduitA",
          name: "aduitA",
          component: aduitA,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "study_curriculum" // 归属父级页面
          }
        },
        {
          // 学习课程
          path: "/group/study_curriculum",
          name: "study_curriculum",
          component: study_curriculum,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "study_curriculum" // 归属父级页面
          }
        },
        {
          // 上传课程
          path: "/group/add_upload_course",
          name: "add_upload_course",
          component: add_upload_course,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "study_curriculum" // 归属父级页面
          }
        },

        {
          // 直播课程
          path: "/group/live_curriculum",
          name: "live_curriculum",
          component: live_curriculum,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "live_curriculum" // 归属父级页面
          }
        },
        {
          // 添加直播
          path: "/group/add_curriculum",
          name: "add_curriculum",
          component: add_curriculum,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "live_curriculum" // 归属父级页面
          }
        },
        {
          // 直播回看
          path: "/group/back_look",
          name: "back_look",
          component: back_look,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "live_curriculum" // 归属父级页面
          }
        },
        //-----------------------  组织管理 -------------------------------
        {
          // 部门管理
          path: "/group/Department_management",
          name: "Department_management",
          component: Department_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Department_management" // 归属父级页面
          }
        },
        {
          // 职工管理
          path: "/group/Staff_management",
          name: "Staff_management",
          component: Staff_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Staff_management" // 归属父级页面
          }
        },
        //添加职工
        {
          path: "/group/addStaff",
          name: "addStaff",
          component: addStaff,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Staff_management" // 归属父级页面
          }
        },
        //导入职工
        {
          path: "/group/Staff_importtemplate",
          name: "Staff_importtemplate",
          component: Staff_importtemplate,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Staff_management" // 归属父级页面
          }
        },
        {
          // 职位管理
          path: "/group/Position_management",
          name: "Position_management",
          component: Position_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Position_management" // 归属父级页面
          }
        },
        {
          // 职位管理(新增)
          path: "/group/Position_managementAdd",
          name: "Position_managementAdd",
          component: Position_managementAdd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Position_management" // 归属父级页面
          }
        },
        {
          // 教职工查询
          path: "/group/Faculty",
          name: "Faculty",
          component: Faculty,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Faculty" // 归属父级页面
          }
        },
        //教职工详情
        {
          path: "/group/queryStaff",
          name: "queryStaff",
          component: queryStaff,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Faculty" // 归属父级页面
          }
        },
        {
          // 假期管理
          path: "/group/Holiday_management",
          name: "Holiday_management",
          component: Holiday_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Holiday_management" // 归属父级页面
          }
        },
        {
          // 表单管理
          path: "/group/form_management",
          name: "form_management",
          component: form_management,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "form_management" // 归属父级页面
          }
        },
        {
          // 表单设置
          path: "/group/form_managementset",
          name: "form_managementset",
          component: form_managementset,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "form_management" // 归属父级页面
          }
        },
        {
          // 请假管申请
          path: "/group/Leave_management_approval",
          name: "Leave_management_approval",
          component: Leave_management_approval,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Leave_management_approval" // 归属父级页面
          }
        },
        {
          // 新增假管申请
          path: "/group/Leave_management_approvalAdd",
          name: "Leave_management_approvalAdd",
          component: Leave_management_approvalAdd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Leave_management_approval" // 归属父级页面
          }
        },
        {
          // 请假审批
          path: "/group/Leave_approval",
          name: "Leave_approval",
          component: Leave_approval,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Leave_approval" // 归属父级页面
          }
        },
        {
          // 审批
          path: "/group/approval",
          name: "approval",
          component: approval,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Leave_approval" // 归属父级页面
          }
        },
        {
          // 调课申请
          path: "/group/Approvalofcourse_adjustment",
          name: "Approvalofcourse_adjustment",
          component: Approvalofcourse_adjustment,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Approvalofcourse_adjustment" // 归属父级页面
          }
        },
        {
          // 新增调课申请
          path: "/group/class_switching_approval",
          name: "class_switching_approval",
          component: class_switching_approval,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Approvalofcourse_adjustment" // 归属父级页面
          }
        },
        {
          // 调课审批(列表)
          path: "/group/Coursetransfer_application",
          name: "Coursetransfer_application",
          component: Coursetransfer_application,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Coursetransfer_application" // 归属父级页面
          }
        },
        {
          // 调课审批
          path: "/group/Coursetransfer_approval",
          name: "Coursetransfer_approval",
          component: Coursetransfer_approval,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Coursetransfer_application" // 归属父级页面
          }
        },

        // ------------------------ 听评课  -------------------------------------------------------
        {
          // 在线听评课
          path: "/group/Onlinelisteningevaluation",
          name: "Onlinelisteningevaluation",
          component: Onlinelisteningevaluation,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "Onlinelisteningevaluation" // 归属父级页面
          }
        },
        {
          // 发表听课留言
          path: "/group/Post_ecture_Notes",
          name: "Post_ecture_Notes",
          component: Post_ecture_Notes,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Onlinelisteningevaluation" // 归属父级页面
          }
        },
        {
          // 创建听评课
          path: "/group/Createlistening",
          name: "Createlistening",
          component: Createlistening,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Onlinelisteningevaluation" // 归属父级页面
          }
        },
        {
          // 听评课详情
          path: "/group/Teacher_classification",
          name: "Teacher_classification",
          component: Teacher_classification,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Onlinelisteningevaluation" // 归属父级页面
          }
        },
        {
          // 管理听评课
          path: "/group/Management_listening",
          name: "Management_listening",
          component: Management_listening,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "Onlinelisteningevaluation" // 归属父级页面
          }
        },
        {
          // 上传录播课
          path: "/group/broadcasting_course",
          name: "broadcasting_course",
          component: broadcasting_course,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "broadcasting_course" // 归属父级页面
          }
        },
        {
          // 自主学习
          path: "/group/AutonomousLearning",
          name: "AutonomousLearning",
          component: AutonomousLearning,
          meta: {
            keepAlive: true, // 不需要缓存当前页面
            rank: 1,
            attribution: "AutonomousLearning" // 归属父级页面
          }
        },
        {
          // 自主学习 资源详情
          path: "/group/selfStudyDetails",
          name: "selfStudyDetails",
          component: selfStudyDetails,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "AutonomousLearning", // 归属父级页面
            attributions: "AutonomousLearning" // 返回指定页面
          }
        },
        {
          // 自主学习 练习题详情
          path: "/group/selfStudyExercises",
          name: "selfStudyExercises",
          component: selfStudyExercises,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 3,
            attribution: "AutonomousLearning", // 归属父级页面
            attributions: "AutonomousLearning" // 返回指定页面
          }
        },
        {
          // 学段学科管理
          path: "/group/resourceManage",
          name: "resourceManage",
          component: resourceManage,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "resourceManage" // 归属父级页面
          }
        },
        {
          // 资源目录
          path: "/group/resourceCatalog",
          name: "resourceCatalog",
          component: resourceCatalog,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "resourceCatalog" // 归属父级页面
          }
        },
        {
          // 个人资源列表
          path: "/group/resourcePersonage",
          name: "resourcePersonage",
          component: resourcePersonage,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "resourceCatalog" // 归属父级页面
          }
        },
        {
          // 个人资源下的资源目录
          path: "/group/resourcePersonageCatalog",
          name: "resourcePersonageCatalog",
          component: resourceCatalog,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "resourceCatalog" // 归属父级页面
          }
        },
        {
          // 上传资源
          path: "/group/resourceUpload",
          name: "resourceUpload",
          component: resourceUpload,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "resourceUpload" // 归属父级页面
          }
        },
        {
          // 资源审核
          path: "/group/resourceAudit",
          name: "resourceAudit",
          component: resourceAudit,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "resourceAudit" // 归属父级页面
          }
        },
        {
          // 敏感词
          path: "/group/sensitive",
          name: "sensitive",
          component: sensitive,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "sensitive" // 归属父级页面
          }
        },
        //--------------------公文管理-------------------
        {
          // 公文管理
          path: "/group/documentManagement",
          name: "documentManagement",
          component: documentManagement,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: "crx1",
            attribution: "documentManagement" // 归属父级页面
          }
        },
        {
          // 收文登记
          path: "/group/Receipt_of_registration",
          name: "Receipt_of_registration",
          component: Receipt_of_registration,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: "5",
            attribution: "documentManagement", // 归属父级页面
            attributions: "documentManagement" // 返回指定页面
          }
        },
        {
          // 信息中心
          path: "/group/informationCenter",
          name: "informationCenter",
          component: informationCenter,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "informationCenter" // 归属父级页面
          }
        },
        {
          // 信息详情
          path: "/group/informationDetail",
          name: "informationDetail",
          component: informationDetail,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "informationCenter" // 归属父级页面
          }
        },
        {
          // 信息回复
          path: "/group/informationReply",
          name: "informationReply",
          component: informationReply,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "informationCenter" // 归属父级页面
          }
        },
        {
          // 转发
          path: "/group/informationTransmit",
          name: "informationTransmit",
          component: informationTransmit,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "informationCenter" // 归属父级页面
          }
        },
        {
          // 草稿箱
          path: "/group/drafts",
          name: "drafts",
          component: drafts,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "informationCenter" // 归属父级页面
          }
        },
        {
          // 编辑草稿
          path: "/group/editDrafts",
          name: "editDrafts",
          component: editDrafts,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "informationCenter" // 归属父级页面
          }
        },
        {
          // 回收站
          path: "/group/recycleBin",
          name: "recycleBin",
          component: recycleBin,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "informationCenter" // 归属父级页面
          }
        },
        //---------------传递课堂--------------------
        {
          path: "/group/PassedtheClassroom",
          name: "PassedtheClassroom",
          component: PassedtheClassroom,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "PassedtheClassroom" // 归属父级页面
          }
        },
        {
          path: "/group/PassedtheClassroomAdd",
          name: "PassedtheClassroomAdd",
          component: PassedtheClassroomAdd,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "PassedtheClassroom" // 归属父级页面
          }
        },
        {
          // 专递课表
          path: "/group/delivery_schedule",
          name: "delivery_schedule",
          component: delivery_schedule,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "delivery_schedule" // 归属父级页面
          }
        },
        //---------------互动授权管理--------------------
        {
          // 互动授权管理
          path: "/group/authorizedManage",
          name: "authorizedManage",
          component: authorizedManage,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "authorizedManage" // 归属父级页面
          }
        },
        {
          // 学校授权
          path: "/group/schoolAuthorized",
          name: "schoolAuthorized",
          component: schoolAuthorized,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "authorizedManage" // 归属父级页面
          }
        },
        {
          // 角色授权
          path: "/group/roleAuthorized",
          name: "roleAuthorized",
          component: roleAuthorized,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "schoolAuthorized" // 归属父级页面
          }
        },
        {
          // 区管授权
          path: "/group/regionalAuthorized",
          name: "regionalAuthorized",
          component: regionalAuthorized,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "authorizedManage" // 归属父级页面
          }
        },
        //---------------校园OA--------------------
        {
          // 父级页面
          path: "/group/school_office",
          name: "school_office",
          component: school_office,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "school_office" // 归属父级页面
          }
        },
        // 创建表单
        {
          path: "/group/school_create_form",
          name: "school_create_form",
          component: school_create_form,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "school_office" // 归属父级页面
          }
        },
        // 表单详情
        {
          path: "/group/school_form_details",
          name: "school_form_details",
          component: school_form_details,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "school_office" // 归属父级页面
          }
        },
        //---------------数据驾驶舱--------------------
        // 数据总览
        {
          path: "/group/dataScreening",
          name: "dataScreening",
          component: dataScreening,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "dataScreening" // 归属父级页面
          }
        },
        // 区域数据
        {
          path: "/group/areaData",
          name: "areaData",
          component: areaData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "areaData" // 归属父级页面
          }
        },
        // 学校数据
        {
          path: "/group/schoolData",
          name: "schoolData",
          component: schoolData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "schoolData" // 归属父级页面
          }
        },
        // 教职工数据
        {
          path: "/group/staffData",
          name: "staffData",
          component: staffData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "staffData" // 归属父级页面
          }
        },
         // 教学档案
        {
          path: "/group/staffArchives",
          name: "staffArchives",
          component: staffArchives,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "staffData" // 归属父级页面
          }
        },
        // 学生数据
        {
          path: "/group/studentData",
          name: "studentData",
          component: studentData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "studentData" // 归属父级页面
          }
        },
        // 学生档案
        {
          path: "/group/studentArchives",
          name: "studentArchives",
          component: studentArchives,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "studentData" // 归属父级页面
          }
        },
        // 平台数据
        {
          path: "/group/platformData",
          name: "platformData",
          component: platformData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "platformData" // 归属父级页面
          }
        },
        // 软件数据
        {
          path: "/group/softwareData",
          name: "softwareData",
          component: softwareData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "softwareData" // 归属父级页面
          }
        },
        // 设备数据
        {
          path: "/group/equipmentData",
          name: "equipmentData",
          component: equipmentData,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 1,
            attribution: "equipmentData" // 归属父级页面
          }
        },
        // 设备数据详情
        {
          path: "/group/equipmentDataDetails",
          name: "equipmentDataDetails",
          component: equipmentDataDetails,
          meta: {
            keepAlive: false, // 不需要缓存当前页面
            rank: 2,
            attribution: "equipmentData" // 归属父级页面
          }
        }
      ]
    },
    //教研室链接跳转页面
    {
      path: "/roomlink",
      name: "roomlink",
      component: roomlink,
      meta: {
        type: "adhoc"
      }
    },
    // h5 页面
    {
      // 发表听课留言-h5分析页
      path: "/group/Post_ecture_Notes_h",
      name: "Post_ecture_Notes_h",
      component: Post_ecture_Notes_h,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 班级报告详情
      path: "/shareimg",
      name: "shareimg",
      component: h5_imgShare,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 教研室手机链接分享
      path: "/InviteLink",
      name: "InviteLink",
      component: h5_InviteLink,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 手机直播详情
      path: "/LiveDetail",
      name: "LiveDetail",
      component: h5_LiveDetail,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 手机录播详情
      path: "/VideoDetail",
      name: "VideoDetail",
      component: h5_VideoDetail,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 分享链接删除跳转页
      path: "/phoneWwh",
      name: "phoneWwh",
      component: h5_Wwh,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 手机登录
      path: "/login",
      name: "login",
      component: h5_login,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 忘记密码
      path: "/forgetPwd",
      name: "forgetPwd",
      component: h5_forget,
      meta: {
        type: "adhoc"
      }
    },
    {
      // 修改密码
      path: "/setPwd",
      name: "setPwd",
      component: h5_setpwd,
      meta: {
        type: "adhoc"
      }
    },
    // 文香传平 扫码下载
    {
      path: "/thescreenh5",
      name: "thescreenh5",
      component: thescreenh5,
      meta: {
        type: "adhoc"
      }
    },
    // 单点登录
    {
      path: "/SSOA",
      name: "SSOA",
      component: SSOA,
      meta: {
        type: "adhoc"
      }
    },
    // 聊天界面客户端
    {
      path: "/h5_chatpc",
      name: "h5_chatpc",
      component: h5_chatpc,
      meta: {
        type: "adhoc"
      }
    },
    // app
    {
      path: "/h5_chatapp",
      name: "h5_chatapp",
      component: h5_chatapp,
      meta: {
        type: "adhoc"
      }
    },
    // 注册
    {
      path: "/bindinUser",
      name: "bindinUser",
      component: bindinUser,
      meta: {
        type: "adhoc"
      }
    },
    // 绑定用户区分
    {
      path: "/oneIndex",
      name: "oneIndex",
      component: oneIndex,
      meta: {
        type: "adhoc"
      }
    },
    // 手机验证码登录
    {
      path: "/phoneNumberLogin",
      name: "phoneNumberLogin",
      component: phoneNumberLogin,
      meta: {
        type: "adhoc"
      }
    },
    // 绑定用户
    {
      path: "/bindinUserinfo",
      name: "bindinUserinfo",
      component: bindinUserinfo,
      meta: {
        type: "adhoc"
      }
    },

    {
      path: "/bindinUserOk",
      name: "bindinUserOk",
      component: bindinUserOk,
      meta: {
        type: "adhoc"
      }
    }
  ]
});
// 针对前端升级导致左侧路由导航点击无反应
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    location.reload();
  }
});
// 账号管理 跳转当下路由时修改路由下的meta.attribution菜单归属（回显当前所在菜单选项样式）
const routerUrl = ['/group/addpupil','/group/addStaff','/group/addteacher','/group/teacherimpot','/group/Staff_importtemplate','/group/pupilimpot','/group/wx_district_add',"/group/wx_review","/group/theremotecontrol","/group/wx_information_publish",'/group/wx_information_add',"/group/FileToPush","/group/addfile"];
router.beforeEach((to,from,next) =>{
  if(routerUrl.indexOf(to.path) !== -1){
    to.meta.attribution = from.meta.attribution; 
    next()
  }else{
    next()
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js